import React, { useContext, useEffect, useState } from "react";
import {
  getBmiValue,
  getHarrisBenedict,
  getInitialAnamnesis,
  getMeasurementDataByMeasurementDate,
  getPalValue,
  getPathologies,
  getSingleQuestionnaireScore,
  getQuestionnaireScores,
  getRiskFactor,
  getTeeValue,
  getTherapiesData,
  getThresholdData,
  updateThresholdValue,
  getDrugIntakeLogs,
  getBloodPressureMood,
} from "../../../../../../service-layer/MeasurementService";

import { getDrugAssumptionNotificationsByUserId, getPatientEducationalNotificationsByUserId } from "../../../../../../service-layer/PatientService";

import { useStateContext } from "../../../../../../contextProvider";

import {
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from "chart.js";
import Chart from "chart.js/auto";
import { useLocation, useNavigate } from "react-router-dom";
import ScatterPlot from "./components/scatterPlot/ScatterPlot";
import "./UserDetailsPage.css";
import { register } from "swiper/element/bundle";
import MedicineCard from "./components/MedicineCard/MedicineCard";
import NotificationCard from "./components/NotificationCard/NotificationCard";
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
// CONVERSION TO EXCEL IMPORT
import * as XLSX from 'xlsx';


// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import PatientDetailsCard from "./components/PatientDetailsCard/PatientDetailsCard";
import ListCard from "./components/LifestyleCard/ListCard";

// DOWNLOAD CSV
import JSZip from "jszip";
import { saveAs } from "file-saver";

// REACT SPINNER
import ClipLoader from "react-spinners/ClipLoader";

import { CButton, CCol, CContainer, CFormInput, CRow, CDropdownMenu, CDropdownToggle, CDropdownItem, CDropdown } from "@coreui/react";
import { useTranslation } from "react-i18next";
import {
  getBloodPressureMeasurementsPerUser,
  getBloodPressureNotificationsPerUser,
  getEducationalNotifications,
} from "../../../../../../service-layer/AdminService";
import CCardDashboard from "./components/CCard/CCardDashboard";
import LogoutModal from "../../../../../components/logout-moal/LogoutModal";
import dayjs from "dayjs";
import ScatterPlotContainer from "../ScatterPlotContainer/ScatterPlotContainer";

import { HEALTH_METRIC_TAGS } from "../../../../config/thresholds";
import { validateBloodPressureThresholds, getThresholdValidationLimits, validateSingleBloodPressureThreshold } from '../../../../config/thresholds';


register();

const UserDetailsPage = () => {
  const activitiesNames = [
    "passi",
    "distanza",
    "acqua",
    "kilocalorie bruciate",
    "battito cardiaco",
  ];




  const location = useLocation();
  const { medicalStaffId, patientId, patientData } = location.state;
  const [patientDetails, setPatientDetails] = useState(patientData);

  let totalUser = 1;
    useState(true);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [singlePressureInsertions, setSinglePressureInsertions] = useState([]);
  const [pressureInsertions, setPressureInsertions] = useState(0);
  const [last7daysInteractions, setLast7daysInteractions] = useState([]);
  const [palValue, setPalValue] = useState(undefined);
  const [loadingPalValue, setLoadingPalValue] = useState(true);
  const [teeValue, setTeeValue] = useState(undefined);
  const [loadingTeeValue, setLoadingTeeValue] = useState(true);
  const [totalChatbotInteractions, setTotalChatbotInteractions] = useState(0);

  const [ pressureMoods, setPressureMoods] = useState([])

  const [last7daysInsertions, setLast7daysInsertions] = useState([]);
  const [last30daysInteractions, setLast30daysInteractions] = useState([]);
  const [last30daysInsertions, setLast30daysInsertions] = useState([]);

  // LOADING STATES
  const [loadingInteractions, setLoadingInteractions] = useState(true);
  const [loadingInsertions, setLoadingInsertions] = useState(true);
  const [loadingTotalUsers, setLoadingTotalUsers] = useState(true);
  const [hasErrorDate, setHasErrorDate] = useState(false);
  const [loadingByDate, setLoadingByDate] = useState(false);
  const [hasErrorPressure, setHasErrorPressure] = useState(false);
  const [loadingByPressure, setLoadingByPressure] = useState(false);
  const [monthlyChatbotInteractions, setMonthlyChatbotInteractions] = useState(
    [],
  );
  const [monthlyInsertions, setMonthlyInsertions] = useState([]);
  const [maxInteractions, setMaxInteractions] = useState(0);
  const [minInteractions, setMinInteractions] = useState(0);
  const [maxInsertions, setMaxInsertions] = useState(0);
  const [minInsertions, setMinInsertions] = useState(0);
  const [loadingMonthlyInteractions, setLoadingMonthlyInteractions] =
    useState(true);
  const [loadingMonthlyInsertions, setLoadingMonthlyInsertions] =
    useState(true);
  const [loadingInteractionsChart, setLoadingInteractionsChart] =
    useState(true);
  const [loading7daysInteractionsChart, setLoading7daysInteractionsChart] =
    useState(true);
  const [loadingInsertionsChart, setLoadingInsertionsChart] = useState(true);
  const [loading7daysInsertionsChart, setLoading7daysInsertionsChart] =
    useState(true);
  
  const [loadingHeartRate, setLoadingHeartRate] = useState(true);

  const [hasErrorThresholdValidation, setHasErrorThresholdValidation] = useState(false);
  const [thresholdValidationError, setThresholdValidationError] = useState('');


  // DAYS DIFFERENCE
  const [interactionsDaysDifference, setInteractionDaysDifference] =
    useState(undefined);
  const [insertionsDaysDifference, setInsertionsDaysDifference] =
    useState(undefined);

 // STATE CONTEXT
  const { selectedPatient, setSelectedPatient, selectedPatientData, 
    setSelectedPatientData, doctorPage, setDoctorPage } = useStateContext()

  // HANDLING OF DRUG ASSUMPTION NOTIFICATIONS
  // const [loadingAdherence, setLoadingAdherence] = useState(true);
  // const [therapyAdherence, setTherapyAdherence] = useState(0);
  // const [correctAssumptions, setCorrectAssumptions] = useState(0);
  // const [loadingTotalNotifications, setLoadingTotalNotifications] = useState(true);

  // EDUCATIONAL NOTIFICATIONS
  const [ loadingEducationalNotifications, setLoadingEducationalNotifications ] = useState(true);
  const [ educationalNotifications, setEducationalNotifications] = useState([])

  const sData = {
    datasets: [
      {
        label: "Min Blood Pressure",
        data: [],
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
        pointRadius: 5,
      },
      {
        label: "Max Blood Pressure",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
        pointRadius: 5,
      },
    ],
  };

  function transformDate(dateTime) {
    return dateTime.split(".")[0];
  }

  function lastDaysEvents(event, days, type) {
    const now = new Date();
    let events = [];
    if (type === 1)
      events = event
        .filter(
          (ev) =>
            Math.abs(new Date(ev.messageDateTime) - now) <= 86400000 * days,
        )
        .map((ev) => {
          return { ...ev, eventDateTime: ev.messageDateTime };
        });
    else if (type === 2)
      events = event
        .filter(
          (ev) =>
            Math.abs(new Date(ev.measurementDate) - now) <= 86400000 * days,
        )
        .map((ev) => {
          return { ...ev, eventDateTime: ev.measurementDate };
        });
    //console.log("WEEK EVENTS", week_events)

    // assegno giorno specifico
    events = events.map((ev) => {
      let date = new Date(ev.eventDateTime);
      let day = date.getDate();
      let month = getMonthString(date.getMonth() + 1).slice(0, 3);

      const day_string = `${month} ${day < 10 ? "0" + day : day}`;

      return {
        day: day_string,
      };
    });

    let days_events = events
      .map((ev) => ev.day)
      .filter((ev, ind, arr) => arr.indexOf(ev) === ind);

    days_events = days_events.map((day) => {
      let day_events = events.filter((ev) => ev.day === day).length;

      return {
        day: day,
        events: day_events,
      };
    });

    //console.log("7 DAYS EVENTS", days_events)
    let last_days = [];
    for (let i = 0; i < days; i++) {
      let day = new Date();
      day.setDate(day.getDate() - i);
      let day_string = `${getMonthString(day.getMonth() + 1).slice(0, 3)} ${day.getDate() > 9 ? day.getDate() : "0" + day.getDate()}`;

      let day_events = days_events.filter((day) => day.day === day_string);
      //console.log("7 DAYS EVENTS", day_string)

      last_days.push({
        day: day_string,
        events: day_events.length > 0 ? day_events[0].events : 0,
      });
    }

    last_days.reverse();
    //console.log("LAST DAYS", last_days)
    if (type === 1 && days === 7) setLast7daysInteractions(last_days);
    else if (type === 2 && days === 7) setLast7daysInsertions(last_days);
    if (type === 1 && days === 30) setLast30daysInteractions(last_days);
    else if (type === 2 && days === 30) setLast30daysInsertions(last_days);
  }

  function getMonthString(month) {
    const month_names = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return month_names[month - 1];
  }

  function monthlyPressureInsertionsHandler(insertions) {
    let monthly_insertions = [];

    const oldest_date = new Date(insertions[0].measurementDate);
    let oldest_month = oldest_date.getMonth() + 1;
    let oldest_year = oldest_date.getFullYear();

    const recent_date = new Date(
      insertions[insertions.length - 1].measurementDate,
    );
    let recent_month = recent_date.getMonth() + 1;
    let recent_year = recent_date.getFullYear();

    const diffInDays = daysDifference(oldest_date, recent_date);
    setInsertionsDaysDifference(diffInDays);

    const total_months =
      (recent_year - oldest_year) * 12 + (recent_month - oldest_month) + 1;

    let current_year = oldest_year;
    let current_month = oldest_month;

    for (let i = 0; i < total_months; i++) {
      let insertion_count = insertions.filter((insertion) => {
        const insertion_time = new Date(insertion.measurementDate);
        let insertion_month = insertion_time.getMonth() + 1;
        let insertion_year = insertion_time.getFullYear();

        return (
          insertion_month === current_month && insertion_year === current_year
        );
      }).length;

      monthly_insertions.push({
        id: i,
        insertions: insertion_count,
        month: `${getMonthString(current_month)} `,
        year: `${current_year} `,
      });

      if (current_month === 12) {
        current_month = 1;
        current_year += 1;
      } else current_month += 1;
    }

    console.log("MONTHLY INSERTIONS", monthly_insertions);

    setMonthlyInsertions(monthly_insertions);
    setLoadingMonthlyInsertions(false);
    setLoading7daysInsertionsChart(false);
    setLoadingInsertionsChart(false);
    let monthly_insertions_number = monthly_insertions.map(
      (m) => m.measurementDate,
    );
    setMinInsertions(Math.min(...monthly_insertions_number));
    setMaxInsertions(Math.max(...monthly_insertions_number));
  }

  function daysDifference(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Get the difference in milliseconds
    const diffInMs = Math.abs(endDate - startDate);

    // Convert milliseconds to days
    return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
  }

  useEffect(() => {
    getBloodPressureMeasurementsPerUser(patientId)
      .then((response) => {
        const totalMeasurements = response.data;
        let totalPressureInsertions = [];

        for (let i = 0; i < totalMeasurements.length - 1; i++) {
          totalMeasurements[i].measurementDate = transformDate(
            totalMeasurements[i].measurementDate,
          ); // tolgo millisecondi perché alcuni inserimenti hanno piccole latenze
          totalMeasurements[i + 1].measurementDate = transformDate(
            totalMeasurements[i + 1].measurementDate,
          );
          if (
            ((totalMeasurements[i].measurementId === 11 &&
              totalMeasurements[i + 1].measurementId === 12) ||
              (totalMeasurements[i].measurementId === 12 &&
                totalMeasurements[i + 1].measurementId === 11)) &&
            totalMeasurements[i].measurementDate ===
              totalMeasurements[i + 1].measurementDate &&
            totalMeasurements[i].userId === totalMeasurements[i + 1].userId
          ) {
            totalPressureInsertions.push({
              userId: totalMeasurements[i].userId,
              measurementDate: totalMeasurements[i].measurementDate,
              maxPressure:
                totalMeasurements[i].measurementId === 12
                  ? totalMeasurements[i].measurementValue
                  : totalMeasurements[i + 1].measurementValue,
              minPressure:
                totalMeasurements[i].measurementId === 11
                  ? totalMeasurements[i].measurementValue
                  : totalMeasurements[i + 1].measurementValue,
            });
            i += 1;
          } else {
            totalPressureInsertions.push({
              userId: totalMeasurements[i].userId,
              measurementDate: totalMeasurements[i].measurementDate,
              maxPressure:
                totalMeasurements[i].measurementId === 12
                  ? totalMeasurements[i].measurementValue
                  : -1,
              minPressure:
                totalMeasurements[i].measurementId === 11
                  ? totalMeasurements[i].measurementValue
                  : -1,
            });
          }
        }

        //console.log("TOTALLLL", totalPressureInsertions)
        setSinglePressureInsertions(totalPressureInsertions);

        // numero totale inserimenti
        setPressureInsertions(totalPressureInsertions.length);

        setLoadingInsertions(false);

        // numero totale di inserimenti al mese
        monthlyPressureInsertionsHandler(totalPressureInsertions);

        // interazioni negli ultimi 7 giorni
        lastDaysEvents(totalPressureInsertions, 7, 2);
        lastDaysEvents(totalPressureInsertions, 30, 2);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // function calculateAdherence(correct_assumptions, total) {
  //   let user_correct_assumptions = correct_assumptions.length;


  //   setTotalNotifications(total);
  //   setCorrectAssumptions(user_correct_assumptions);
  //   setTherapyAdherence(100 * (user_correct_assumptions / total));

  //   setLoadingAdherence(false);
  //   setLoadingTotalUsers(false);
  //   setLoadingTotalNotifications(false);
  // }

  useEffect(() => {
    // getDrugAssumptionNotificationsByUserId(patientId).then((response) => {
    //   if (response.status === 200) {
    //     const total_drug_notifications = response.data.length

    //     getDrugIntakeLogs(patientId).then((res) => {
    //           calculateAdherence(res, total_drug_notifications);
    //     })

    //   }
    // });

    getPatientEducationalNotificationsByUserId(patientId).then((res) => {
      if(res.data)
      {
        const notifications = res.data

        let new_notifications = extractNotificationInfo(notifications)

        setEducationalNotifications(new_notifications)
        setLoadingEducationalNotifications(false)
      }
      else{
        setLoadingEducationalNotifications("N/A")
      }
    }).catch(err => {
      console.error("ERRORE NEL RECUPERO DELLE NOTIFICHE EDUCATIVE", err)
      setShowLogoutModal(true)
      setLoadingEducationalNotifications("N/A")
    })
  }, [patientId]);

  // TOOL PER ESTRARRE TESTO, TITOLO E DATA DELLE NOTIFICHE
  // ----------------------------------------------
  const extractNotificationInfo = (notifications) => {
    
    const new_notifications = notifications.map(notification => {
      const notification_json = JSON.parse(notification.text)
      const body = notification_json.Notification.body
      const title = notification_json.Notification.title
      // set Date and Hour
      const timestamp = Number(notification_json.Data.timestamp)
      
      return {
        title: title, body: body, timestamp: timestamp
      }
    })

    // console.log("NEW NOTIFICATIONS", new_notifications)

    return new_notifications
  }
  // ----------------------------------------------

  const [minBloodPressureData, setMinBloodPressureData] = useState([
    {
      measurement_date: "",
      value: 0,
    },
  ]);
  const [minBloodPressureDataComplete, setMinBloodPressureDataComplete] = useState([
    {
      measurement_date: "",
      value: 0,
    },
  ]);
  const [medianMinPressure, setMedianMinPressure] = useState("");
  const [medianMaxPressure, setMedianMaxPressure] = useState("");

  const [maxBloodPressureData, setMaxBloodPressureData] = useState([
    {
      measurement_date: "",
      value: 0,
    },
  ]);
  const [maxBloodPressureDataComplete, setMaxBloodPressureDataComplete] = useState([
    {
      measurement_date: "",
      value: 0,
    },
  ]);

  const [heartBeatData, setHeartBeatData] = useState([
    {
      measurement_date: "",
      value: 0,
    },
  ]);
  const [heartBeatDataComplete, setHeartBeatDataComplete] = useState([
    {
      measurement_date: "",
      value: 0,
    },
  ]);

    // QUESTIONNAIRES DATA
  const ID_TEST_FAGERSTROM = 14;
  const ID_TEST_STRESS = 5;
  const ID_HYPERTENSION_AWARENESS = 16;
  const ID_BLOOD_PRESSURE_MONITORING = 17;
  const ID_THERAPY_ADHERENCE = 18;
  const ID_DIET = 19;
  const ID_PHYSICAL_ACTIVITY = 20;
  const ID_SLEEP = 22;

  const [ questionnaireData, setQuestionnaireData ] = useState([
    {
      name: "fagerstrom_test_score",
      score: "N/A",
      questionnaire_id: ID_TEST_FAGERSTROM,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.FAGERSTROM_SCORE
    },
    {
      name: "stress_test_score",
      score: "N/A",
      questionnaire_id: ID_TEST_STRESS,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.STRESS_SCORE
    },
    {
      name: "hypertension_awareness_score",
      score: "N/A",
      questionnaire_id: ID_HYPERTENSION_AWARENESS,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.HYPERTENSION_AWARENESS_SCORE
    },
    {
      name: "blood_pressure_monitoring_score",
      score: "N/A",
      questionnaire_id: ID_BLOOD_PRESSURE_MONITORING,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.BLOOD_PRESSURE_MONITORING_SCORE
    },
    {
      name: "therapy_adherence_score",
      score: "N/A",
      questionnaire_id: ID_THERAPY_ADHERENCE,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.THERAPY_ADHERENCE_SCORE
    },
    {
      name: "diet_score",
      score: "N/A",
      questionnaire_id: ID_DIET,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.DIET_SCORE
    },
    {
      name: "physical_activity_score",
      score: "N/A",
      questionnaire_id: ID_PHYSICAL_ACTIVITY,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.PHYSICAL_ACTIVITY_SCORE
    },
    {
      name: "sleep_score",
      score: "N/A",
      questionnaire_id: ID_SLEEP,
      patientData: patientDetails[0],
      healthMetricTag: HEALTH_METRIC_TAGS.SLEEP_SCORE
    }
  ])

  const [scatterPlotData, setScatterPlotData] = useState(sData);
  const [thresholdData, setThresholdData] = useState({
    lowerThreshold: 0,
    upperThreshold: 0,
  });
  const [riskFactor, setRiskFactor] = useState(-1);
  const [bmiValue, setBmiValue] = useState(-1);
  const [benedictValue, setBenedictValue] = useState(-1);
  const [initialAnamnesis, setInitialAnamnesis] = useState([]);
  const [therapies, setTherapies] = useState([]);
  const [originalTherapies, setOriginalTherapies] = useState([]);
  const [pathologies, setPathologies] = useState([]);

  const [patientAge, setPatientAge] = useState(undefined)

  // LOADING STATES
  const [loadingPatientInfo, setLoadingPatientInfo] = useState(true);
  const [loadingBMI, setLoadingBMI] = useState(true);
  const [loadingCardioRisk, setLoadingCardioRisk] = useState(true);
  const [loadingBenedict, setLoadingBenedict] = useState(true);
  const [loadingTherapies, setLoadingTherapies] = useState(true);
  const [loadingPathologies, setLoadingPathologies] = useState(true);
  const [loadingLifestyle, setLoadingLifestyle] = useState(true);
  const [loadingPressureScatter, setLoadingPressureScatter] = useState(true);
  const [loadingQuestionnaire, setLoadingQuestionnaire] = useState(true);
  const { t } = useTranslation();

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const currentDate = dayjs();
  const threeMonthsAgo = currentDate.subtract(4, "month");
  const formattedEndDate = currentDate.format("YYYY-MM-DD");
  const formattedStartDate = threeMonthsAgo.format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(formattedStartDate);
  const [endDate, setEndDate] = useState(formattedEndDate);

  const [maxPressure, setMaxPressure] = useState(0);
  const [minPressure, setMinPressure] = useState(0);
  const [avgMaxPressure, setAvgMaxPressure] = useState(0);
  const [minMaxPressure, setMinMaxPressure] = useState(0);
  const [maxMaxPressure, setMaxMaxPressure] = useState(0);
  const [numMeasurementMaxPressure, setNumMeasurementMaxPressure] = useState(0);
  const [maxMinPressure, setMaxMinPressure] = useState(0);
  const [avgMinPressure, setAvgMinPressure] = useState(0);
  const [minMinPressure, setMinMinPressure] = useState(0);
  const [numMeasurementMinPressure, setnumMeasurementMinPressure] = useState(0);
  const [numberOfUpdatePressure, setNumberOfUpdatePressure] = useState(0);
  const [fagerstromScore, setFagerstromScore] = useState(undefined);

  const [avgHeartRate, setAvgHeartRate] = useState(0);
  const [minHeartRate, setMinHeartRate] = useState(0);
  const [maxHeartRate, setMaxHeartRate] = useState(0);
  const [numMeasurementHeartRate, setNumMeasurementHeartRate] = useState(0);


  const handleConfirm = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("name");
    localStorage.removeItem("surname");
    localStorage.removeItem("authority");

    localStorage.removeItem("doctor_page");
    localStorage.removeItem("patient_id");
    localStorage.removeItem("staff_id");
    
    localStorage.removeItem("patient_data");
    localStorage.removeItem("patient_name");
    localStorage.removeItem("patient_surname");


    setSelectedPatient(undefined)
    setSelectedPatientData(undefined)
    setDoctorPage(undefined)

    setShowLogoutModal(false);
    navigate("/");
  };

  // Function to handle minimum pressure input change
  const handleMinPressureChange = (e) => {
    const value = e.target.value;
    
    // Allow empty string or valid numbers
    if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
      setMinPressure(value === '' ? 0 : parseFloat(value));
      
      // Clear validation error when user starts typing
      // if (hasErrorThresholdValidation) {
      //   setHasErrorThresholdValidation(false);
      //   setThresholdValidationError('');
      // }
    }
  };

  // Function to handle maximum pressure input change
  const handleMaxPressureChange = (e) => {
    const value = e.target.value;
    
    // Allow empty string or valid numbers
    if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
      setMaxPressure(value === '' ? 0 : parseFloat(value));
      
      // Clear validation error when user starts typing
      // if (hasErrorThresholdValidation) {
      //   setHasErrorThresholdValidation(false);
      //   setThresholdValidationError('');
      // }
    }
  };

  Chart.register(
    CategoryScale,
    LinearScale,
    RadialLinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );
  const heartBeatId = 10;
  const bloodPressureMinId = 11;
  const bloodPressureMaxId = 12;

  const sortTherapiesByDate = (a, b) => {
    const startDateA = new Date(a.startDate).getTime();
    const startDateB = new Date(b.startDate).getTime();

    if (startDateA < startDateB) return 1;
    else return -1;
  };

  // Function to transform therapy objects into desired format
  const transformTherapies = (therapies) => {
    console.log("THERAPIESSSS", therapies);
    return therapies.sort(sortTherapiesByDate).map((therapy) => {
      // Split days of the week by comma and format them
      const daysOfTheWeek = therapy.daysOfTheWeek
        .split(",")
        .map((day) => {
          return day.substring(0, 3).toUpperCase(); // Take first 3 letters and convert to uppercase
        })
        .join(", ");

      // Create array of intake times and quantities
      const intakeTimes = therapy.intakeSelectedTimes.split(",");
      const intakeQuantities = therapy.intakeSelectedQuantities.split(",");

      const intake = intakeTimes.map((time, index) => ({
        quantity: intakeQuantities[index],
        time: `${time}`,
      }));

      return {
        drugUnit: therapy.drugUnit,
        daysOfTheWeek,
        intake,
        drugName: therapy.drugName,
        drugRegularityId: therapy.drugRegularityId,
        intervalUnit: therapy.intervalUnit,
        intervalNumber: therapy.intervalNumber,
        startDate: therapy.startDate,
        endDate: therapy.endDate,
        adherencePercentage: therapy.adherencePercentage,
      };
    });
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (window.localStorage.getItem("auth_token") === null) navigate("/login");
  }, [navigate]);

  useEffect(() => {
    setPatientDetails(patientData);
    setLoadingPatientInfo(false);

    let BMI 
    if(patientDetails[0].weight && patientDetails[0].height)
      BMI = parseInt(patientDetails[0].weight)/Math.pow(parseInt(patientDetails[0].height) / 100, 2)
    else
      BMI = 'N/A'
    if(BMI != 'N/A')
      BMI = BMI.toFixed(2)

    setBmiValue(BMI)    
    setLoadingBMI(false)                

    // calculate BMR
    const BMR = calculateBMR(patientData[0]);
    setBenedictValue(BMR)
    setLoadingBenedict(false)
  }, [patientData]);

  useEffect(() => {
    // axios api call
    getMeasurementDataByMeasurementDate(
      patientId,
      bloodPressureMinId,
      startDate,
      endDate,
    )
      .then((response) => {
        const values = response.map((data) => data.value);
        const medianValue = calculateMedian(values);

        if (values.length !== 0) {
          const total = values.reduce((acc, val) => acc + val, 0);
          const min = Math.min(...values);
          const max = Math.max(...values);
          const average = (total / values.length).toFixed(2);

          setAvgMinPressure(average);
          setMinMinPressure(min);
          setMaxMinPressure(max);
          setnumMeasurementMinPressure(values.length);
        } else {
          setAvgMinPressure(0);
          setMinMinPressure(0);
          setMaxMinPressure(0);
          setnumMeasurementMinPressure(0);
        }
        setMedianMinPressure(medianValue);
        response.sort((a, b) => new Date(a.measurement_date) - new Date(b.measurement_date));
        setMinBloodPressureData(response);
      })
      .catch((e) => {
        console.error("ERROR LOADING MEASUREMENT PRESSURE", e)
        setShowLogoutModal(true);
      });

      // carico anche tutte le misurazioni
      getMeasurementDataByMeasurementDate(
        patientId,
        bloodPressureMinId
      ).then((response) => {
        response.sort((a, b) => new Date(a.measurement_date) - new Date(b.measurement_date));
        setMinBloodPressureDataComplete(response);
      })
      .catch((e) => {
        console.error("ERROR LOADING ALL MEASUREMENT PRESSURE", e)
        setShowLogoutModal(true);
      })

    getMeasurementDataByMeasurementDate(
      patientId,
      bloodPressureMaxId,
      startDate,
      endDate,
    )
      .then((response) => {
        const values = response.map((data) => data.value);
        const medianValue = calculateMedian(values);
        if (values.length !== 0) {
          const total = values.reduce((acc, val) => acc + val, 0);
          const min = Math.min(...values);
          const max = Math.max(...values);
          const average = (total / values.length).toFixed(2);

          setAvgMaxPressure(average);
          setMinMaxPressure(min);
          setMaxMaxPressure(max);
          setNumMeasurementMaxPressure(values.length);
          console.log("MIN PRESSURE------------------------>");
          console.log(response);
        } else {
          setAvgMaxPressure(0);
          setMinMaxPressure(0);
          setMaxMaxPressure(0);
          setNumMeasurementMaxPressure(0);
        }
        setMedianMaxPressure(medianValue);
        response.sort((a, b) => new Date(a.measurement_date) - new Date(b.measurement_date));
        setMaxBloodPressureData(response);
        if (loadingPressureScatter) setLoadingPressureScatter(false);
      })
      .catch((e) => {
        console.error("ERROR LOADING MEASUREMENT PRESSURE BY DATE", e)
        setShowLogoutModal(true);
      });

      getMeasurementDataByMeasurementDate(
        patientId,
        bloodPressureMaxId
      ).then((response) => {
        response.sort((a, b) => new Date(a.measurement_date) - new Date(b.measurement_date));
        setMaxBloodPressureDataComplete(response);
      })
      .catch((e) => {
        console.error("ERROR LOADING ALL MEASUREMENT PRESSURE", e)
        setShowLogoutModal(true);
      });

    getMeasurementDataByMeasurementDate(
      patientId,
      heartBeatId,
      startDate,
      endDate,
    )
      .then((response) => {
        response.sort((a, b) => new Date(a.measurement_date) - new Date(b.measurement_date));
        setHeartBeatData(response);
        calculateHeartRateStats(response);
        setLoadingHeartRate(false);
      })
      .catch((e) => {
        console.error("ERROR LOADING MEASUREMENT HEARTBEAT BY DATE", e)
        setLoadingHeartRate(false);
        setShowLogoutModal(true);
      });

    getRiskFactor(patientId, endDate)
      .then((response) => {
        setRiskFactor(response);
        setLoadingCardioRisk(false);
      })
      .catch((e) => {
        console.error("ERROR LOADING MEASUREMENT RISK FACTOR", e)
        setShowLogoutModal(true);
      });

      getMeasurementDataByMeasurementDate(
        patientId,
        heartBeatId
      ).then((response) => {
        setHeartBeatDataComplete(response);
      })
      .catch((e) => {
        console.error("ERROR LOADING HEART BEAT", e)
        setShowLogoutModal(true);
      });
    // getBmiValue(patientId)
    //   .then((response) => {
    //     setBmiValue(response);
    //     setLoadingBMI(false);
    //   })
    //   .catch(() => {
    //     setShowLogoutModal(true);
    //   });

    // getHarrisBenedict(patientId)
    //   .then((response) => {
    //     setBenedictValue(response);
    //     setLoadingBenedict(false);
    //   })
    //   .catch(() => {
    //     setShowLogoutModal(true);
    //   });

    // getTeeValue(patientId)
    //   .then((response) => {
    //     setTeeValue(response);
    //     setLoadingTeeValue(false);
    //   })
    //   .catch((err) => {
    //     setTeeValue("N/A");
    //     setLoadingTeeValue(false);
    //   });

    getPalValue(patientId)
      .then((response) => {
        console.log("PALLL", response)
        setPalValue(response !== -1 ? response : 'N/A');
        setLoadingPalValue(false);
        // set also TEE
        const BMR = Number(calculateBMR(patientData[0]))
        if(BMR !== 'N/A' && response !== -1)
          setTeeValue((BMR * response).toFixed(1));
        else
          setTeeValue("N/A")
        setLoadingTeeValue(false);
      })
      .catch((err) => {
        setPalValue("N/A");
        setTeeValue("N/A")
        setLoadingPalValue(false);
        setLoadingTeeValue(false);
      });

    getInitialAnamnesis(patientId)
      .then((response) => {
        if(response.length > 1)
          response = response.filter(r => r != 'Nessuna di queste')

        setInitialAnamnesis(response);
        setLoadingLifestyle(false);
      })
      .catch((e) => {
        console.error("ERROR LOADING INITIAL ANAMNESIS", e)
        setShowLogoutModal(true);
      });


    getBloodPressureMood(patientId)
      .then((response) => {
        // console.log("PRESSURE MOOD", response)
        setPressureMoods(response)
      })
      .catch((err) => {
        console.error("ERROR LOADING BLOOD PRESSURE MOOD", err)
        setPressureMoods([])
        // setShowLogoutModal(true)
      })
    

    getTherapiesData(patientId)
      .then((response) => {
        console.log("THERAPIES", response);
        if (response.length === 0) {
          setTherapies(response);
          setLoadingTherapies(false);
        } else {
          setOriginalTherapies(response);
          setTherapies(transformTherapies(response));
          setLoadingTherapies(false);
        }
      })
      .catch((err) => {
        //setShowLogoutModal(true);
        console.log(err);
      });

    getPathologies(patientId)
      .then((response) => {
        if (response.length === 0) {
          response = [];
        }
        response = response.filter(pat => pat !== 'Fumatore')
        setPathologies(response);
        setLoadingPathologies(false);
      })
      .catch((err) => {
        //setShowLogoutModal(true);
        console.log(err);
      });

    getThresholdData(patientId, bloodPressureMinId)
      .then((response) => {
        setThresholdData(response);
        setMaxPressure(response.upperThreshold);
        setMinPressure(response.lowerThreshold);
        console.log("Threshold data loaded:", response);
      })
      .catch((err) => {
        //setShowLogoutModal(true);
        console.log("Error loading thresholds:", err);
        // Set default thresholds if none are available
      setThresholdData({
        lowerThreshold: 90,  // Default diastolic threshold
        upperThreshold: 130  // Default systolic threshold
      });
      });

    // GET QUESTIONNAIRES SCORES
    getQuestionnaireScores(patientId).then(response => {
      const quest_results = response

      let quest_data = questionnaireData
      const quest_ids = questionnaireData.map(quest => quest.questionnaire_id)

      if(quest_results)
      quest_results.forEach(quest => {
        const quest_id = quest.questionnaireId

        if(quest_ids.includes(quest_id)){
          let index = quest_ids.indexOf(quest_id)
          quest_data[index].score = quest.score
        }
        
      })
      

      setQuestionnaireData(quest_data)
      setLoadingQuestionnaire(false);
    })
    .catch((e) => {
      console.error("ERROR LOADING QUESTIONNAIRES", e)
      setShowLogoutModal(true);
    });
    
    
  }, [patientId]);

  useEffect(() => {
    if (minBloodPressureData.length > 0 && maxBloodPressureData.length > 0) {
      const dates = [...maxBloodPressureData, ...minBloodPressureData]
        .map((data) => data.measurement_date)
        .sort((a, b) => a - b);

      const startDate = dates[0];
      const endDate = dates[dates.length - 1];
      /*   console.log("the dates are -------------------------->")
                                                                           console.log(startDate);
                                                                           console.log(endDate);
                                                                           console.log("the dates are -------------------------->")
                                                                           console.log(dates);*/
      const lineDataPoints = [startDate, endDate];
      console.log("the dates are -------------------------->");
      console.log(lineDataPoints);

      const data = {
        datasets:
          thresholdData.lowerThreshold !== undefined &&
          thresholdData.upperThreshold !== undefined
            ? [
                {
                  type: "scatter",
                  label: t("maxBloodPressure"),
                  data: formatData(maxBloodPressureData),
                  // backgroundColor: "rgb(205,153,6)",
                  // borderColor: "rgb(205,153,6)",
                  backgroundColor: "rgba(40,111,158,1)",  // #286f9e
                  borderColor: "rgba(40,111,158,1)",  // #286f9e
                  borderWidth: 2,
                  pointRadius: 3,
                  pointBorderWidth: 1,
                  showLine: true,
                },
                {
                  type: "line",
                  label: t("median_max_blood_pressure"),
                  // backgroundColor: "rgb(255,218,124)",
                  // borderColor: "rgb(255,218,124)",
                  backgroundColor: "rgba(40,111,158,0.5)",   // #286f9e
                  borderColor: "rgba(40,111,158,0.5)",  // #286f9e
                  data: lineDataPoints.map((date) => ({
                    x: date,
                    y: medianMaxPressure,
                  })),
                  borderWidth: 3,
                  fill: false,
                  pointRadius: 0,
                  hide: true
                },
                {
                  type: "scatter",
                  label: t("minBloodPressure"),
                  data: formatData(minBloodPressureData),
                  // backgroundColor: "rgba(31,71,112, 1)",
                  // borderColor: "rgba(31,71,112, 1)",
                  backgroundColor: "rgba(79, 168, 255, 1)",   // #42a1fe
                  borderColor: "rgba(79, 168, 255, 1)",    // #42a1fe
                  borderWidth: 2,
                  pointRadius: 3,
                  pointBorderWidth: 1,
                  showLine: true,
                },
                {
                  type: "line",
                  label: t("median_min_blood_pressure"),
                  // backgroundColor: "rgb(91,173,251)",
                  // borderColor: "rgb(91,173,251)",
                  backgroundColor: "rgba(79, 168, 255, 0.5)",   // #42a1fe
                  borderColor: "rgba(79, 168, 255, 0.5)",   // #42a1fe
                  data: lineDataPoints.map((date) => ({
                    x: date,
                    y: medianMinPressure,
                  })),
                  borderWidth: 3,
                  fill: false,
                  pointRadius: 0,
                  hide: true
                },
                {
                  type: "line",
                  label: t("maxThreshold"),
                  backgroundColor: "rgb(116, 116, 116)",
                  borderColor: "rgb(116, 116, 116)",
                  data: lineDataPoints.map((date) => ({
                    x: date,
                    y: thresholdData.upperThreshold,
                  })),
                  borderWidth: 2,
                  fill: false,
                  pointRadius: 0,
                  borderDash: [7]
                },
                {
                  type: "line",
                  label: t("minThreshold"),
                  data: lineDataPoints.map((date) => ({
                    x: date,
                    y: thresholdData.lowerThreshold,
                  })),
                  backgroundColor: "rgb(34, 34, 34)",
                  borderColor: "rgb(34, 34, 34)",
                  borderWidth: 2,
                  fill: false,
                  pointRadius: 0,
                  borderDash: [7]
                },
                {
                  type: "line",
                  label: "", // Empty label for custom legend item
                  data: lineDataPoints.map((date) => ({
                    x: date,
                    y: 0,
                  })),
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  borderWidth: 3,
                  fill: false,
                },
              ]
            : [
                {
                  type: "scatter",
                  label: t("minBloodPressure"),
                  data: formatData(minBloodPressureData),
                  backgroundColor: "rgba(31,71,112, 1)",
                  borderColor: "rgba(31,71,112, 1)",
                  borderWidth: 2,
                  pointRadius: 5,
                  pointBorderWidth: 1,
                },
                {
                  type: "scatter",
                  label: t("maxBloodPressure"),
                  data: formatData(maxBloodPressureData),
                  backgroundColor: "rgb(205,153,6)",
                  borderColor: "rgb(205,153,6)",
                  borderWidth: 2,
                  pointRadius: 5,
                  pointBorderWidth: 1,
                },
              ],
      };

      // const options = {
      //   scales: {
      //     y: {
      //       beginAtZero: true,
      //       min: 0,
      //     },
      //   },
      //   plugins: {
      //     legend: {
      //       display: true,
      //       labels: {
      //         generateLabels: (chart) => {
      //           const datasets = chart.data.datasets;
      //           const defaultLabels = datasets.map((dataset, i) => ({
      //             text: dataset.label,
      //             fillStyle: dataset.backgroundColor,
      //           }));

      //           // Adding a custom icon/tooltip legend entry
      //           const customIconLegendItem = {
      //             text: "", // Empty label for custom icon
      //             fillStyle: "transparent", // Transparent fill
      //             datasetIndex: null, // No dataset
      //           };

      //           return [...defaultLabels, customIconLegendItem];
      //         },
      //         filter: (legendItem, chartData) => {
      //           return legendItem.text !== "";
      //         },
      //       },
      //       onClick: (e, legendItem) => {
      //         if (legendItem.text === "") {
      //           // If the clicked legend item is the custom icon, do nothing or handle accordingly
      //           return;
      //         }
      //         const index = legendItem.datasetIndex;
      //         const chart = legendItem.chart;
      //         const meta = chart.getDatasetMeta(index);
      //         meta.hidden =
      //           meta.hidden === null
      //             ? !chart.data.datasets[index].hidden
      //             : null;
      //         chart.update();
      //       },
      //     },
      //   },
      // };
      setScatterPlotData(data);
    }
  }, [maxBloodPressureData, minBloodPressureData, t, thresholdData, medianMaxPressure, medianMinPressure]);

  const formatData = (data) => {
    return data.map((item) => ({
      x: new Date(item.measurement_date),
      y: item.value,
    }));
  };

  const intake_regularity = ["daily", "interval", "monthly"];

  // ---------------------------------------------------------------------------------------------
  // --------------------- FUNZIONI PER SALVARE I DATI IN FORMATO CSV ----------------------------
  // ---------------------------------------------------------------------------------------------
  // async function downloadCSVFilesAsZip(files) {
  //   const zip = new JSZip();
  //   files.forEach((file) => {
  //     const csvContent = convertToCSV(file.data);
  //     console.log("CSV CONTENT", csvContent)
  //     zip.file(`${file.filename}.csv`, csvContent);
  //   });

  //   const content = await zip.generateAsync({ type: "blob" });
  //   saveAs(
  //     content,
  //     `${patientDetails[0].name.toLowerCase()}_${patientDetails[0].surname.toLowerCase()}_data`,
  //   );
  // }

  // function replaceAllr(key, value) {
  //   return value === null ? "" : value;
  // }

  // function convertToCSV(data) {
  //   const headers = Object.keys(data[0]);
  //   const csvRows = data.map((row) =>
  //     headers.map((header) => JSON.stringify(row[header], replaceAllr)).join(";"),
  //   );
  //   csvRows.unshift(headers.join(";")); // add header row at the beginning
  //   return csvRows.join("\n");
  // }

  // function prepareDataForCSV() {
  //   console.log("I'm converting to CSV");

  //   let files = [];
  //   // 1) GENERAL INFORMATION FILE
  //   //console.log("DETAILS", patientDetails)
  //   let details;
  //   // add also benedict harris/BMI/cardio risk
  //   details = {
  //     name: patientDetails[0].name,
  //     surname: patientDetails[0].surname,
  //     sex: patientDetails[0].sex,
  //     fiscal_code: patientDetails[0].fiscalCode,
  //     age: patientAge,
  //     birth_date: patientDetails[0].birthDate,
  //     height: patientDetails[0].height,
  //     weight: patientDetails[0].weight,
  //     BMR: benedictValue === 'N/A' ? "" : Number(benedictValue),
  //     cardio_risk_factor: riskFactor === -1 ? "" : Number(riskFactor),
  //     PAL: palValue === 'N/A' ? "" : Number(palValue),
  //     TEE: teeValue === 'N/A' ? "" : Number(teeValue),
  //     fagerstrom_score: fagerstromScore === 'N/A' ? '' : fagerstromScore,
  //     BMI:
  //       bmiValue === 'N/A' ? "" : Number(bmiValue),
  //     therapy_adherence_percentage: therapyAdherence === 'N/A' ? "" : therapyAdherence.toFixed(2),
  //     average_systolic_pressure: avgMaxPressure === 0 ? '' : Number(avgMaxPressure),
  //     average_diastolic_pressure: avgMinPressure === 0 ? '' : Number(avgMinPressure),
  //     max_systolic_pressure: maxMaxPressure === 0 ? '' : maxMaxPressure,
  //     min_systolic_pressure: minMaxPressure === 0 ? '' : minMaxPressure,
  //     max_diastolic_pressure: maxMinPressure === 0 ? '' : maxMinPressure,
  //     min_diastolic_pressure: minMinPressure === 0 ? '' : minMinPressure,
  //     correct_drug_ssumptions: correctAssumptions,
  //     total_drug_assumption_notifications: totalNotifications,
  //     total_educational_notifications: educationalNotifications.length,
  //   };
  //   const data1 = [details];
  //   files.push({
  //     filename: "general_info",
  //     data: data1,
  //   });

  //   // 2) BLOOD PRESSURE INSERTIONS
  //   // console.log("BLOOD DATA", maxBloodPressureData, minBloodPressureData)
  //   if (maxBloodPressureData.length > 0 && minBloodPressureData.length > 0) {
  //     const data2 = maxBloodPressureData.map((m, ind) => {
  //       return {
  //         min_pressure: minBloodPressureData[ind].value,
  //         max_pressure: m.value,
  //         measurement_date: m.measurement_date,
  //       };
  //     });

  //     files.push({
  //       filename: "blood_pressure_insertions",
  //       data: data2,
  //     });
  //   }

  //   // 3) THERAPIES
  //   if (therapies.length > 0) {
  //     const data3 = originalTherapies.map((therapy) => {
  //       let days_of_the_week = therapy.daysOfTheWeek.split(',')
  //       days_of_the_week = days_of_the_week.map(day => t(day));
  //       days_of_the_week = days_of_the_week.join(',')
  //       return {
  //         drug_name: String(therapy.drugName),
  //         drug_unit: t(String(therapy.drugUnit)),
  //         start_therapy: therapy.startDate,
  //         end_therapy: therapy.endDate,
  //         intake_time: String(therapy.intakeSelectedTimes).replaceAll(',', '/'),
  //         intake_quantity: String(therapy.intakeSelectedQuantities).replaceAll('1/4','0.25').replaceAll('1/2','0.5'),
  //         intake_regularity: intake_regularity[therapy.drugRegularityId - 1],
  //         interval_unit: t(therapy.intervalUnit),
  //         number_of_times: therapy.intervalNumber,
  //         weekdays: days_of_the_week,
  //       };
  //     });

  //     //console.log("THERAPY CSV DATA", data3)
  //     files.push({
  //       filename: "therapies",
  //       data: data3,
  //     });
  //   }

  //   // 4) LIFESTYLE AND PATHOLOGIES
  //   const max_length = Math.max(initialAnamnesis.length, pathologies.length);
  //   const min_length = Math.min(initialAnamnesis.length, pathologies.length);
  //   let data4 = [];
  //   // console.log("lifestyle", initialAnamnesis)
  //   // console.log("pathology", pathologies)
  //   if (max_length === initialAnamnesis.length) {
  //     data4 = initialAnamnesis.map((anamnesis, ind) => {
  //       if (ind < min_length)
  //         return {
  //           lifestyle: t(anamnesis),
  //           pathologies: t(pathologies[ind]),
  //         };
  //       else
  //         return {
  //           lifestyle: t(anamnesis),
  //           pathologies: "",
  //         };
  //     });
  //   }

  //   if (max_length === pathologies.length) {
  //     data4 = pathologies.map((pathology, ind) => {
  //       if (ind < min_length)
  //         return {
  //           lifestyle: t(initialAnamnesis[ind]),
  //           pathologies: t(pathology),
  //         };
  //       else
  //         return {
  //           lifestyle: "",
  //           pathologies: t(pathology),
  //         };
  //     });
  //   }
  //   // console.log("LIFESTYLE DATA", data4)
  //   if (data4.length > 0)
  //     files.push({
  //       filename: "lifestyle_and_pathologies",
  //       data: data4,
  //     });

  //   console.log("CSV TO DOWNLOAD", files);
  //   downloadCSVFilesAsZip(files);
  // }
  // ---------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  const downloadExcel = () => {
    console.log("DOWNLOADING EXCEL FILE")

    // 1) GENERAL INFORMATION FILE - SHEET_1
    let sheet_1 = []
    sheet_1.push([
      t("name").replaceAll(' ','_'),
      t("surname").replaceAll(' ','_'),
      t("sex").replaceAll(' ','_'),
      t("fiscalCode").replaceAll(' ','_'),
      t("age").replaceAll(' ','_'),
      t("birth_date").replaceAll(' ','_'),
      t("height").replaceAll(' ','_'),
      t("weight").replaceAll(' ','_'),
      t("benedictValue").replaceAll(' ','_'),
      t("cardiovascularRiskFactor").replaceAll(' ','_'),
      t("cardiovascularRiskFactor_Category").replaceAll(' ','_'),
      t("palValue").replaceAll(' ','_'),
      t("palValue_Category").replaceAll(' ','_'),
      t("teeValue").replaceAll(' ','_'),
      t("fagerstrom_test_score").replaceAll(' ','_'),
      t("fagerstrom_test_score_Category").replaceAll(' ','_'),
      t("stress_test_score").replaceAll(' ','_'),
      t("stress_test_score_Category").replaceAll(' ','_'),
      t("bmiValue").replaceAll(' ','_'),
      t("bmiValue_Category").replaceAll(' ','_'),
      // t("therapyAdherence").replaceAll(' ','_'),
      t("average_max_blood_pressure").replaceAll(' ','_'),
      t("average_diastolic_pressure").replaceAll(' ','_'),
      `${t("max_value")}_${t("maxPressure")}`.replaceAll(' ','_'),
      `${t("min_value")}_${t("maxPressure")}`.replaceAll(' ','_'),
      `${t("max_value")}_${t("minPressure")}`.replaceAll(' ','_'),
      `${t("min_value")}_${t("minPressure")}`.replaceAll(' ','_'),
        t("average_heart_rate").replaceAll(' ','_'),
      `${t("max_value")}_${t("heartBeat")}`.replaceAll(' ','_'),
      `${t("min_value")}_${t("heartBeat")}`.replaceAll(' ','_'),
      `${t("number_of_measurements")}_${t("heartBeat")}`.replaceAll(' ','_'),
      // t("respectedAssumptions").replaceAll(' ','_'),
      // t("totalAssumptionNotifications").replaceAll(' ','_'),
      t("totalEducationalNotifications").replaceAll(' ','_')  
    ]);
    sheet_1.push(
      [
        patientDetails[0].name,
        patientDetails[0].surname,
        patientDetails[0].sex,
        patientDetails[0].fiscalCode,
        patientAge,
        patientDetails[0].birthDate,
        patientDetails[0].height,
        patientDetails[0].weight,
        benedictValue === 'N/A' ? "" : Number(benedictValue),
        riskFactor === -1 ? "" : Number(riskFactor),
        riskFactor === -1 ? "" : getCardiovascularRiskText(riskFactor),
        palValue === 'N/A' ? "" : Number(palValue),
        palValue === 'N/A' || palValue === -1.0 ? "" : getPALCategoryText(palValue),
        teeValue === 'N/A' ? "" : Number(teeValue),
        questionnaireData[0].score === 'N/A' ? '' : questionnaireData[0].score,   //fagerstrom
        questionnaireData[0].score === 'N/A' ? '' : getFagerstromCategoryText(questionnaireData[0].score),   // fagerstrom category
        questionnaireData[1].score === 'N/A' ? '' : questionnaireData[1].score,   // autovalutazione stress
        questionnaireData[1].score === 'N/A' ? '' : getStressCategoryText(questionnaireData[1].score),  // stress category
        bmiValue === 'N/A' ? "" : Number(bmiValue),
        bmiValue === 'N/A' ? "" : getBMICategoryText(bmiValue),
        // therapyAdherence === 'N/A' ? "" : Number(therapyAdherence),
        avgMaxPressure === 0 ? '' : Number(avgMaxPressure),
        avgMinPressure === 0 ? '' : Number(avgMinPressure),
        maxMaxPressure === 0 ? '' : maxMaxPressure,
        minMaxPressure === 0 ? '' : minMaxPressure,
        maxMinPressure === 0 ? '' : maxMinPressure,
        minMinPressure === 0 ? '' : minMinPressure,
        // correctAssumptions,
        // totalNotifications,
        avgHeartRate === 0 ? '' : Number(avgHeartRate),
        maxHeartRate === 0 ? '' : maxHeartRate,
        minHeartRate === 0 ? '' : minHeartRate,
        numMeasurementHeartRate === 0 ? '' : numMeasurementHeartRate,
        educationalNotifications.length
      
    ])

    // 2) MISURAZIONI PRESSORIE - SHEET_2
    let sheet_2 = []
    sheet_2.push([
      t("maxPressure").replaceAll(' ','_'),
      t("minPressure").replaceAll(' ','_'),
      t("heartBeat").replaceAll(' ', '_'),
      t("mood").replaceAll(' ', '_'),
      t("date").replaceAll(' ','_'),
      t("sdMax").replaceAll(' ','_'),
      t("sdMin").replaceAll(' ','_'),
      t("weeklyAvgMax").replaceAll(' ','_'),
      t("weeklyAvgMin").replaceAll(' ','_'),
    ])

    if (maxBloodPressureDataComplete.length > 0 && minBloodPressureDataComplete.length > 0) {
          // create array with heartbeats, because blood pressure can also be without heartbeat
          // posso avere sia misurazioni senza battito che misurazioni che hanno battito = -1
          const heartbeats = maxBloodPressureDataComplete.map((item, index, arr) => {
            const heartbeats_dates = heartBeatDataComplete.map(beat => beat.measurement_date)
            const beat_ind = heartbeats_dates.indexOf(item.measurement_date)
            if(beat_ind !== -1)
              return heartBeatDataComplete[beat_ind].value > 0 ? heartBeatDataComplete[beat_ind].value : ''  // se è -1 ritorno vuoto
            else
              return ''
          })

          const moodDataComplete = maxBloodPressureDataComplete.map((item, index, arr) => {
            const mood_dates = pressureMoods.map(mood => mood.date)

            const mood_ind = mood_dates.indexOf(item.measurement_date)

            if(mood_ind !== -1)
              return pressureMoods[mood_ind].value !== "-1" ? t(pressureMoods[mood_ind].value) : ''
            else
              return ''
          })
          // console.log("MOOD MEASUREMENTS", moodDataComplete)
          // console.log("HEARTBEAT DATA", heartbeats)
          // console.log("PRESSURE DATA", maxBloodPressureDataComplete)
          const sd_max = calculateStandardDeviation(maxBloodPressureDataComplete)
          const sd_min = calculateStandardDeviation(minBloodPressureDataComplete)
          const weeklyAvg_max = calculateWeeklyAvg(maxBloodPressureDataComplete)
          const weeklyAvg_min = calculateWeeklyAvg(minBloodPressureDataComplete)
          const data2 = maxBloodPressureDataComplete.map((m, ind) => {
            return [
              m.value,
              minBloodPressureDataComplete[ind].value,
              heartbeats[ind],
              moodDataComplete[ind],
              new Date(m.measurement_date),
              sd_max[ind],
              sd_min[ind],
              weeklyAvg_max[ind],
              weeklyAvg_min[ind]
            ]
          });
    
          sheet_2 = [...sheet_2, ...data2]
        }

        // console.log("DATA PRESSURE", sheet_2)

    // 3) MISURAZIONI PRESSORIE NEL RANGE DI DATE - SHEET_3
    let sheet_3 = []
    sheet_3.push([
      t("maxPressure").replaceAll(' ','_'),
      t("minPressure").replaceAll(' ','_'),
      t("heartBeat").replaceAll(' ', '_'),
      t("mood").replaceAll(' ', '_'),
      t("date").replaceAll(' ','_'),
      t("sdMax").replaceAll(' ','_'),
      t("sdMin").replaceAll(' ','_'),
      t("weeklyAvgMax").replaceAll(' ','_'),
      t("weeklyAvgMin").replaceAll(' ','_'),
    ])

    if (maxBloodPressureData.length > 0 && minBloodPressureData.length > 0) {
          // create array with heartbeats, because blood pressure can also be without heartbeat
          // posso avere sia misurazioni senza battito che misurazioni che hanno battito = -1
          const heartbeats = maxBloodPressureData.map((item, index, arr) => {
            const heartbeats_dates = heartBeatData.map(beat => beat.measurement_date)
            const beat_ind = heartbeats_dates.indexOf(item.measurement_date)
            if(beat_ind !== -1)
              return heartBeatData[beat_ind].value > 0 ? heartBeatData[beat_ind].value : ''  // se è -1 ritorno vuoto
            else
              return ''
          })

          const moodData = maxBloodPressureData.map((item, index, arr) => {
            const mood_dates = pressureMoods.map(mood => mood.date)

            const mood_ind = mood_dates.indexOf(item.measurement_date)

            if (mood_ind !== -1)
              return pressureMoods[mood_ind].value !== "-1"  ? t(pressureMoods[mood_ind].value) : ''
            else
              return ''
          })
          // console.log("MOOD MEASUREMENTS", moodData)
          // console.log("HEARTBEAT DATA", heartbeats)
          // console.log("PRESSURE DATA", maxBloodPressureData)
          const sd_max = calculateStandardDeviation(maxBloodPressureData)
          const sd_min = calculateStandardDeviation(minBloodPressureData)
          const weeklyAvg_max = calculateWeeklyAvg(maxBloodPressureData)
          const weeklyAvg_min = calculateWeeklyAvg(minBloodPressureData)
          const data3 = maxBloodPressureData.map((m, ind) => {
            return [
              m.value,
              minBloodPressureData[ind].value,
              heartbeats[ind],
              moodData[ind],
              new Date(m.measurement_date),
              sd_max[ind],
              sd_min[ind],
              weeklyAvg_max[ind],
              weeklyAvg_min[ind]
            ]
          });
    
          sheet_3 = [...sheet_3, ...data3]
        }


    // 4) THERAPIES - sheet_4
    let sheet_4 = []
    sheet_4.push([
      t("drugName").replaceAll(' ', '_'),
      t("drugUnit").replaceAll(' ', '_'),
      t("startDate").replaceAll(' ', '_'),
      t("endDate").replaceAll(' ', '_'),
      t("intakeTime").replaceAll(' ', '_'),
      t("intakeQuantity").replaceAll(' ', '_'),
      t("intakeRegularity").replaceAll(' ', '_'),
      t("intervalUnit").replaceAll(' ', '_'),
      t("numberOfTimes").replaceAll(' ', '_'),
      t("weekDays").replaceAll(' ', '_'),
      t("adherencePercentage").replaceAll(' ', '_')
    ])

    if (therapies.length > 0) {
      const data3 = originalTherapies.map((therapy) => {
        let days_of_the_week = therapy.daysOfTheWeek.split(',')
        days_of_the_week = days_of_the_week.map(day => t(day));
        days_of_the_week = days_of_the_week.join(',')
        return [
          String(therapy.drugName),
          t(String(therapy.drugUnit)),
          new Date(therapy.startDate),
          new Date(therapy.endDate),
          String(therapy.intakeSelectedTimes).replaceAll(',', '/'),
          String(therapy.intakeSelectedQuantities).replaceAll('1/4','0.25').replaceAll('1/2','0.5'),
          t(`${intake_regularity[therapy.drugRegularityId - 1]}`),
          t(therapy.intervalUnit),
          therapy.intervalNumber,
          days_of_the_week,
          therapy.adherencePercentage ? therapy.adherencePercentage.toFixed(2) + '%' : 'N/A'
        ]
      });
      sheet_4 = [...sheet_4, ...data3]
    }


    // 5) LIFESTYLE AND PATHOLOGIES - sheet_5
    let sheet_5 = []
    sheet_5.push([
      t("lifestyleInformation").replaceAll(' ', '_'),
      t("pathologies").replaceAll(' ', '_')
    ])
    const max_length = Math.max(initialAnamnesis.length, pathologies.length);
    const min_length = Math.min(initialAnamnesis.length, pathologies.length);

    let data4 = [];
    // console.log("lifestyle", initialAnamnesis)
    // console.log("pathology", pathologies)
    if (max_length === initialAnamnesis.length) {
      data4 = initialAnamnesis.map((anamnesis, ind) => {
        if (ind < min_length)
          return [
            t(anamnesis),
            t(pathologies[ind])
          ];
        else
          return [
            t(anamnesis),
            ""
          ];
      });
      sheet_5 = [...sheet_5, ...data4]
    }

    if (max_length === pathologies.length) {
      data4 = pathologies.map((pathology, ind) => {
        if (ind < min_length)
          return [
            t(initialAnamnesis[ind]),
            t(pathology)
          ]
        else
          return [
            "",
            t(pathology)
          ];
      });
      sheet_5 = [...sheet_5, ...data4]
    }
    
    // 6) EDUCATIONAL NOTIFICATIONS - sheet_6
    let sheet_6 = []
    sheet_6.push([
      t("educationalNotificationTitle").replaceAll(' ', '_'),
      t("educationalNotificationText").replaceAll(' ', '_'),
      t("timestamp").replaceAll(' ', '_')
    ])

    if(educationalNotifications.length>0){
      const data5 = educationalNotifications.map(notification => {
        return [
          notification.title,
          notification.body,
          new Date(notification.timestamp*1000)
        ]
      })
      sheet_6 = [...sheet_6, ...data5]
    }

    // Create sheets
    const ws1 = XLSX.utils.aoa_to_sheet(sheet_1);
    const ws2 = XLSX.utils.aoa_to_sheet(sheet_2);
    const ws3 = XLSX.utils.aoa_to_sheet(sheet_3);
    const ws4 = XLSX.utils.aoa_to_sheet(sheet_4);
    const ws5 = XLSX.utils.aoa_to_sheet(sheet_5);
    const ws6 = XLSX.utils.aoa_to_sheet(sheet_6);

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Append sheets to workbook
    XLSX.utils.book_append_sheet(wb, ws1, t("generalInformation"));
    XLSX.utils.book_append_sheet(wb, ws2, t("pressureInsertions"));
    XLSX.utils.book_append_sheet(wb, ws3, t("insertionsRangeExcel"));
    XLSX.utils.book_append_sheet(wb, ws4, t("totalTherapies"));
    XLSX.utils.book_append_sheet(wb, ws5, t("pathologiesLifestyle"));
    XLSX.utils.book_append_sheet(wb, ws6, t("educationalNotifications"));

    // Export the workbook
    XLSX.writeFile(wb, `${patientId}.xlsx`);

  }

  const downloadPDF = () => {
    console.log("DOWNLOADING PDF FILE")
  }

  const calculateMedian = (values) => {
    values.sort((a, b) => a - b);
    const half = Math.floor(values.length / 2);
    if (values.length % 2) {
      return values[half];
    } else {
      return (values[half - 1] + values[half]) / 2.0;
    }
  };

  const calculateStandardDeviation = (values) => {
    values = values.map(value => { if(value.value) return value.value;
      else return 0
    }).filter(val => val > 0)
    const sd = values.map((value, ind, arr) => {
      const values_until_now = arr.filter((val, i) => i<=ind )
      let sum = 0
      const mean = values_until_now.reduce((accumulator, currentValue) => accumulator + currentValue, sum)/(ind + 1)
      // sum of (val - mean)^2
      let squared_sum = 0
      const square_sum = values_until_now.reduce((accumulator, currentValue) => accumulator + Math.pow(currentValue - mean, 2), squared_sum)
      return Math.sqrt(square_sum/(ind+1))
    })
    return sd
  }

  const calculateWeeklyAvg = (values) => {
    values = values.map(val => {if(val.value) return {value: val.value, datetime: new Date(val.measurement_date)}
    else return {value: 0, datetime: new Date(val.measurement_date)}
  }).filter(val => val.value > 0)

    const globalWeeklyAvg = values.map((value, ind, arr) => {
      const values_until_now = arr.filter((val, i) => i<=ind )
      // console.log("VALUES UNTIL NOW", values_until_now)
      const date_until_now = new Date(values_until_now[values_until_now.length-1].datetime)
      const date_until_now_week = date_until_now
      date_until_now_week.setDate(date_until_now.getDate() - 7)
      // console.log("DATE LIMIT WEEK", date_until_now_week)

      const values_last_week = values_until_now.filter(val => val.datetime>=date_until_now_week).map(val => val.value)
      // console.log("VALUES LAST WEEK", values_last_week)

      let weeklySum = 0
      const weeklyAvg = values_last_week.reduce((accumulator, val) => accumulator + val, weeklySum)/values_last_week.length
      // console.log("AVG LAST WEEK", weeklyAvg)

      return weeklyAvg
    })

  return globalWeeklyAvg

  }

  const calculateHeartRateStats = (heartRateData) => {
  if (heartRateData.length === 0) {
    setAvgHeartRate(0);
    setMinHeartRate(0);
    setMaxHeartRate(0);
    setNumMeasurementHeartRate(0);
    return;
  }

  const values = heartRateData.map((data) => data.value).filter(value => value > 0);
  
  if (values.length === 0) {
    setAvgHeartRate(0);
    setMinHeartRate(0);
    setMaxHeartRate(0);
    setNumMeasurementHeartRate(0);
    return;
  }

  const total = values.reduce((acc, val) => acc + val, 0);
  const average = (total / values.length).toFixed(2);
  const min = Math.min(...values);
  const max = Math.max(...values);

  setAvgHeartRate(average);
  setMinHeartRate(min);
  setMaxHeartRate(max);
  setNumMeasurementHeartRate(values.length);
};

  const handleDateRangeSearch = () => {
    setLoadingByDate(true);
    setLoadingHeartRate(true);
    getMeasurementDataByMeasurementDate(
      patientId,
      bloodPressureMinId,
      startDate,
      endDate,
    )
      .then((response) => {
        const values = response.map((data) => data.value);
        const medianValue = calculateMedian(values);
        if (values.length !== 0) {
          const total = values.reduce((acc, val) => acc + val, 0);
          const min = Math.min(...values);
          const max = Math.max(...values);
          const average = (total / values.length).toFixed(2);

          setAvgMinPressure(average);
          setMinMinPressure(min);
          setMaxMinPressure(max);
          setnumMeasurementMinPressure(values.length);
        } else {
          setAvgMinPressure(0);
          setMinMinPressure(0);
          setMaxMinPressure(0);
          setnumMeasurementMinPressure(0);
        }
        setMedianMinPressure(medianValue);
        setMinBloodPressureData(response);

        if (loadingPressureScatter) setLoadingPressureScatter(false);
        // setLoadingByDate(false);
      })
      .catch((e) => {
        console.error("ERROR LOADING HANDLE DATE RANGE SEARCH", e)
        setShowLogoutModal(true);
      });

    getMeasurementDataByMeasurementDate(
      patientId,
      bloodPressureMaxId,
      startDate,
      endDate,
    )
      .then((response) => {
        const values = response.map((data) => data.value);
        const medianValue = calculateMedian(values);

        if (values.length !== 0) {
          const total = values.reduce((acc, val) => acc + val, 0);
          const min = Math.min(...values);
          const max = Math.max(...values);
          const average = (total / values.length).toFixed(2);

          setAvgMaxPressure(average);
          setMinMaxPressure(min);
          setMaxMaxPressure(max);
          setNumMeasurementMaxPressure(values.length);
          console.log("MIN PRESSURE------------------------>");
          console.log(response);
        } else {
          setAvgMaxPressure(0);
          setMinMaxPressure(0);
          setMaxMaxPressure(0);
          setNumMeasurementMaxPressure(0);
        }

        setMedianMaxPressure(medianValue);
        setMaxBloodPressureData(response);
        if (loadingPressureScatter) setLoadingPressureScatter(false);
      })
      .catch((e) => {
        console.error("ERROR LOADING GETMESUREMENTDATABYMEASDATE", e)
        setShowLogoutModal(true);
      });
    
      getMeasurementDataByMeasurementDate(
        patientId,
        heartBeatId,
        startDate,
        endDate,
      )
        .then((response) => {
          response.sort((a, b) => new Date(a.measurement_date) - new Date(b.measurement_date));
          setHeartBeatData(response);
          calculateHeartRateStats(response);
          setLoadingHeartRate(false);
          setLoadingByDate(false);
        })
        .catch((e) => {
          console.error("ERROR LOADING HEART BEAT DATA BY DATE", e);
          setLoadingHeartRate(false);
          setShowLogoutModal(true);
        });

    getRiskFactor(patientId, endDate)
      .then((response) => {
        setRiskFactor(response);
        setLoadingCardioRisk(false);
        setLoadingByDate(false);
      })
      .catch((e) => {
        console.error("ERROR GET RISK FACTOR", e)
        setShowLogoutModal(true);
      });

  };

  const handleConfirmPressure = () => {
    console.log(minPressure);
    console.log(maxPressure);
    
    // Validate systolic (max) pressure using single value validation
    const systolicValidation = validateSingleBloodPressureThreshold(maxPressure, true);
    
    // Validate diastolic (min) pressure using single value validation
    const diastolicValidation = validateSingleBloodPressureThreshold(minPressure, false);
    
    // Check if either validation fails
    if (!systolicValidation.isValid || !diastolicValidation.isValid) {
      let errorMessage = '';
      
      // Handle systolic validation error
      if (!systolicValidation.isValid) {
        let systolicError = t(systolicValidation.errorKey);
        if (systolicValidation.errorParams) {
          Object.keys(systolicValidation.errorParams).forEach(key => {
            systolicError = systolicError.replace(`{${key}}`, systolicValidation.errorParams[key]);
          });
        }
        errorMessage = systolicError;
      }
      
      // Handle diastolic validation error
      if (!diastolicValidation.isValid) {
        let diastolicError = t(diastolicValidation.errorKey);
        if (diastolicValidation.errorParams) {
          Object.keys(diastolicValidation.errorParams).forEach(key => {
            diastolicError = diastolicError.replace(`{${key}}`, diastolicValidation.errorParams[key]);
          });
        }
        
        // If both have errors, combine them
        if (errorMessage) {
          errorMessage += ' | ' + diastolicError;
        } else {
          errorMessage = diastolicError;
        }
      }
      
      setHasErrorThresholdValidation(true);
      setThresholdValidationError(errorMessage);
      return; // Stop execution if validation fails
    }
    
    // Additional check: ensure max > min with sufficient difference
    if (minPressure >= maxPressure) {
      setHasErrorThresholdValidation(true);
      setThresholdValidationError(t("the_max_pressure_should_be_greater_than_the_min_pressure"));
      return;
    }
    console.log("VALIDATION PASSED, UPDATING PRESSURE");
    // Clear any existing validation errors
    setHasErrorThresholdValidation(false);
    setThresholdValidationError('');
    
    setLoadingByPressure(true);
    updateThresholdValue(patientId, minPressure, maxPressure)
      .then((response) => {
        console.log("pressure updated");
        setNumberOfUpdatePressure(numberOfUpdatePressure + 1);
        setLoadingByPressure(false);
      })
      .catch((err) => {
        setLoadingByPressure(false);
        console.log(err);
      });
  };

  // useEffect(() => {
  //   if ((minPressure > 0 || maxPressure > 0)) {
  //     let hasValidationError = false;
  //     let errorMessages = [];
      
  //     // Validate systolic (max) pressure if entered
  //     if (maxPressure > 0) {
  //       console.log("VALIDATING SYSTOLIC PRESSURE", maxPressure);
  //       const systolicValidation = validateSingleBloodPressureThreshold(maxPressure, true);
  //       console.log("SYSTOLIC VALIDATION", systolicValidation);
  //       if (!systolicValidation.isValid) {
  //         hasValidationError = true;
  //         let systolicError = t(systolicValidation.errorKey);
  //         if (systolicValidation.errorParams) {
  //           Object.keys(systolicValidation.errorParams).forEach(key => {
  //             systolicError = systolicError.replace(`{${key}}`, systolicValidation.errorParams[key]);
  //           });
  //         }
  //         errorMessages.push(systolicError);
  //         console.log("hasValidationError", hasValidationError);
  //         console.log("SYSTOLIC ERROR", systolicError);
  //       }
  //     }
      
  //     // Validate diastolic (min) pressure if entered
  //     if (minPressure > 0) {
  //       console.log("VALIDATING DIASTOLIC PRESSURE", minPressure);
  //       const diastolicValidation = validateSingleBloodPressureThreshold(minPressure, false);
  //       console.log("DIASTOLIC VALIDATION", diastolicValidation);
  //       if (!diastolicValidation.isValid) {
  //         hasValidationError = true;
  //         let diastolicError = t(diastolicValidation.errorKey);
  //         if (diastolicValidation.errorParams) {
  //           Object.keys(diastolicValidation.errorParams).forEach(key => {
  //             diastolicError = diastolicError.replace(`{${key}}`, diastolicValidation.errorParams[key]);
  //           });
  //         }
  //         errorMessages.push(diastolicError);
  //         console.log("hasValidationError", hasValidationError);
  //         console.log("DIASTOLIC ERROR", diastolicError);
  //       }
  //     }

  //     console.log("hasValidationError", hasValidationError);
  //     console.log("errorMessages", errorMessages);
      
  //     // Check if max > min when both values are present
  //     if (minPressure > 0 && maxPressure > 0 && minPressure >= maxPressure) {
  //       hasValidationError = true;
  //       errorMessages.push(t("the_max_pressure_should_be_greater_than_the_min_pressure"));
  //     }
  //     console.log("hasValidationError after max > min check", hasValidationError);
      
  //     if (hasValidationError) {
  //       console.log("Setting hasErrorThresholdValidation to true");
  //       console.log("Setting thresholdValidationError to", errorMessages.join(' | '));
  //       setHasErrorThresholdValidation(true);
  //       setThresholdValidationError(errorMessages.join(' | '));
  //     } 
  //     else if (hasErrorThresholdValidation) {
  //       console.log("Clearing hasErrorThresholdValidation and thresholdValidationError");
  //       setHasErrorThresholdValidation(false);
  //       setThresholdValidationError('');
  //     }
  //   } else if (hasErrorThresholdValidation) {
  //     console.log("Inputs are empty, clearing validation errors");
  //     // Clear errors when inputs are empty
  //     setHasErrorThresholdValidation(false);
  //     setThresholdValidationError('');
  //   }

  //   console.log("Final hasErrorThresholdValidation:", hasErrorThresholdValidation);
  // }, [minPressure, maxPressure, t]);

  useEffect(() => {
    console.log("RUNNING COMPREHENSIVE VALIDATION - maxPressure:", maxPressure, "minPressure:", minPressure);
    
    // Reset all error states first
    let hasValidationError = false;
    let errorMessages = [];

    // Only validate if we have actual values (not just 0)
    if (maxPressure > 0 || minPressure > 0) {
      
      // Validate systolic (max) pressure if entered
      if (maxPressure > 0) {
        console.log("VALIDATING SYSTOLIC PRESSURE", maxPressure);
        const systolicValidation = validateSingleBloodPressureThreshold(maxPressure, true);
        console.log("SYSTOLIC VALIDATION", systolicValidation);
        
        if (!systolicValidation.isValid) {
          hasValidationError = true;
          let systolicError = t(systolicValidation.errorKey);
          if (systolicValidation.errorParams) {
            Object.keys(systolicValidation.errorParams).forEach(key => {
              systolicError = systolicError.replace(`{${key}}`, systolicValidation.errorParams[key]);
            });
          }
          console.log("SYSTOLIC ERROR", systolicError);
          errorMessages.push(systolicError);
        }
      }
      
      // Validate diastolic (min) pressure if entered
      if (minPressure > 0) {
        console.log("VALIDATING DIASTOLIC PRESSURE", minPressure);
        const diastolicValidation = validateSingleBloodPressureThreshold(minPressure, false);
        console.log("DIASTOLIC VALIDATION", diastolicValidation);
        
        if (!diastolicValidation.isValid) {
          hasValidationError = true;
          let diastolicError = t(diastolicValidation.errorKey);
          if (diastolicValidation.errorParams) {
            Object.keys(diastolicValidation.errorParams).forEach(key => {
              diastolicError = diastolicError.replace(`{${key}}`, diastolicValidation.errorParams[key]);
            });
          }
          console.log("DIASTOLIC ERROR", diastolicError);
          errorMessages.push(diastolicError);
        }
      }

      // Check max > min only if both values are present AND both individual validations pass
      if (minPressure > 0 && maxPressure > 0 && !hasValidationError) {
        console.log("CHECKING MAX > MIN PRESSURE", maxPressure, "vs", minPressure);
        if (minPressure >= maxPressure) {
          hasValidationError = true;
          errorMessages.push(t("the_max_pressure_should_be_greater_than_the_min_pressure"));
          console.log("MAX PRESSURE IS NOT GREATER THAN MIN PRESSURE");
        }
      }

      console.log("FINAL hasValidationError:", hasValidationError);
      console.log("FINAL errorMessages:", errorMessages);

      // Update validation states
      if (hasValidationError) {
        console.log("SETTING ERROR STATE TO TRUE");
        setHasErrorThresholdValidation(true);
        setThresholdValidationError(errorMessages.join(' | '));
      } else {
        console.log("CLEARING ERROR STATE");
        setHasErrorThresholdValidation(false);
        setThresholdValidationError('');
      }

      // Update pressure comparison error state separately
      if (minPressure > 0 && maxPressure > 0 && minPressure >= maxPressure) {
        setHasErrorPressure(true);
      } else {
        setHasErrorPressure(false);
      }
      
    } else {
      // Clear all errors when inputs are empty
      console.log("INPUTS ARE EMPTY - CLEARING ALL ERRORS");
      setHasErrorThresholdValidation(false);
      setThresholdValidationError('');
      setHasErrorPressure(false);
    }

    console.log("VALIDATION COMPLETE - hasErrorThresholdValidation will be:", hasValidationError ? true : false);
  }, [minPressure, maxPressure, t]);
  
// Add this temporarily right after your useEffect for debugging
  useEffect(() => {
    console.log("=== VALIDATION STATE DEBUG ===");
    console.log("hasErrorThresholdValidation:", hasErrorThresholdValidation);
    console.log("thresholdValidationError:", thresholdValidationError);
    console.log("hasErrorDate:", hasErrorDate);
    console.log("hasErrorPressure:", hasErrorPressure);
    console.log("===============================");
  }, [hasErrorThresholdValidation, thresholdValidationError, hasErrorDate, hasErrorPressure]);

  useEffect(() => {
    getThresholdData(patientId, bloodPressureMinId)
      .then((response) => {
        setThresholdData(response);
        setLoadingPressureScatter(false);
      })
      .catch((err) => {
        //setShowLogoutModal(true);
        console.log(err);
      });
  }, [numberOfUpdatePressure]);
  useEffect(() => {
    if (dayjs(startDate).isAfter(dayjs(endDate))) {
      setHasErrorDate(true);
    } else {
      setHasErrorDate(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (minPressure > maxPressure && minPressure > 0 && maxPressure > 0) {
      setHasErrorPressure(true);
    } else {
      setHasErrorPressure(false);
    }
  }, [minPressure, maxPressure]);

  const token = window.localStorage.getItem("auth_token");

  function calculateBMR(patientData){
    const weight = patientData.weight
    const height = patientData.height

    let date1 = new Date(patientData.birthDate);  // Later date
    let date2 = new Date();  // Today date

    let yearDifference = date2.getFullYear() - date1.getFullYear();

    // Check if the full year has completed by comparing months and days
    if (
      date2.getMonth() < date1.getMonth() || 
      (date1.getMonth() === date2.getMonth() && date2.getDate() < date1.getDate())
    ) {
      yearDifference--;  // Subtract one if the current year isn't fully completed
    }

    console.log("PATIENT AGE", yearDifference)

    setPatientAge(yearDifference)

    if(!weight || !height)
      return 'N/A'
    else if(patientData.sex === 'M'){
      const res = 66.473 + (13.7516 * Number(weight)) + (5.0033 * Number(height)) - (yearDifference * 6.755)
      console.log("BENEDICT", res)
      return res.toFixed(1)
    }
    else if(patientData.sex === 'F'){
      const res = 655.095 + (9.563 * Number(weight)) + (1.8496 * Number(height)) - (4.6756 * yearDifference)
      return res.toFixed(1)
    }

  }

  const getCardiovascularRiskText = (riskValue) => {
    if (riskValue === -1 || riskValue === null || riskValue === undefined) {
      return "N/A";
    }
    
    const riskPercentage = parseFloat(riskValue);
    
    if (riskPercentage < 2.5) {
      return t("cardiovascular_risk_low");
    } else if (riskPercentage >= 2.5 && riskPercentage < 7.5) {
      return t("cardiovascular_risk_moderate");
    } else if (riskPercentage >= 7.5 && riskPercentage < 15) {
      return t("cardiovascular_risk_high");
    } else {
      return t("cardiovascular_risk_very_high");
    }
  };

  const getBMICategoryText = (bmiValue) => {
    if (bmiValue === 'N/A' || bmiValue === null || bmiValue === undefined || bmiValue === -1) {
      return null; // Return null so no secondary title is shown
    }
    
    const bmi = parseFloat(bmiValue);
    
    if (isNaN(bmi)) {
      return null;
    }
    
    if (bmi < 18.5) {
      return t("bmi_underweight");
    } else if (bmi >= 18.5 && bmi <= 24.9) {
      return t("bmi_normal");
    } else if (bmi >= 25 && bmi <= 29.9) {
      return t("bmi_overweight");
    } else if (bmi >= 30 && bmi <= 34.9) {
      return t("bmi_obesity_grade_1");
    } else if (bmi >= 35 && bmi <= 39.9) {
      return t("bmi_obesity_grade_2");
    } else {
      return t("bmi_obesity_grade_3");
    }
  };

  const getPALCategoryText = (palValue) => {
    if (palValue === 'N/A' || palValue === null || palValue === undefined || palValue === -1) {
      return null; // Return null so no secondary title is shown
    }
    
    const pal = parseFloat(palValue);
    
    if (isNaN(pal)) {
      return null;
    }
    
    if (pal <= 1.2) {
      return t("pal_sedentary");
    } else if (pal > 1.2 && pal <= 1.375) {
      return t("pal_light");
    } else if (pal > 1.375 && pal <= 1.55) {
      return t("pal_moderate");
    } else if (pal > 1.55 && pal <= 1.725) {
      return t("pal_high");
    } else {
      return t("pal_very_high");
    }
  };

  const getFagerstromCategoryText = (fagerstromScore) => {
    if (fagerstromScore === 'N/A' || fagerstromScore === null || fagerstromScore === undefined || fagerstromScore === -1) {
      return null; // Return null so no secondary title is shown
    }
    
    const score = parseInt(fagerstromScore);
    
    if (isNaN(score)) {
      return null;
    }
    
    if (score >= 1 && score <= 2) {
      return t("fagerstrom_low_dependence");
    } else if (score >= 3 && score <= 5) {
      return t("fagerstrom_moderate_dependence");
    } else if (score >= 6 && score <= 7) {
      return t("fagerstrom_strong_dependence");
    } else if (score >= 8 && score <= 10) {
      return t("fagerstrom_very_strong_dependence");
    } else {
      return null; // For scores outside the expected range
    }
  };

  const getStressCategoryText = (stressScore) => {
    if (stressScore === 'N/A' || stressScore === null || stressScore === undefined || stressScore === -1) {
      return null; // Return null so no secondary title is shown
    }
    
    const score = parseInt(stressScore);
    
    if (isNaN(score)) {
      return null;
    }
    
    if (score >= 0 && score <= 10) {
      return t("stress_low_level");
    } else if (score >= 11 && score <= 20) {
      return t("stress_moderate_level");
    } else if (score >= 21 && score <= 30) {
      return t("stress_high_level");
    } else {
      return null; // For scores outside the expected range
    }
  };

  const getHypertensionAwarenessCategoryText = (score) => {
    if (score === 'N/A' || score === null || score === undefined || score === -1) {
      return null;
    }
    
    const numScore = parseInt(score);
    if (isNaN(numScore)) return null;
    
    // Adjust these ranges based on your scoring system
    if (numScore >= 0 && numScore <= 33) {
      return t("hypertension_awareness_low");
    } else if (numScore >= 34 && numScore <= 66) {
      return t("hypertension_awareness_moderate");
    } else if (numScore >= 67 && numScore <= 100) {
      return t("hypertension_awareness_high");
    }
    return null;
  };

  const getBloodPressureMonitoringCategoryText = (score) => {
    if (score === 'N/A' || score === null || score === undefined || score === -1) {
      return null;
    }
    
    const numScore = parseInt(score);
    if (isNaN(numScore)) return null;
    
    // Adjust these ranges based on your scoring system
    if (numScore >= 0 && numScore <= 33) {
      return t("blood_pressure_monitoring_poor");
    } else if (numScore >= 34 && numScore <= 66) {
      return t("blood_pressure_monitoring_fair");
    } else if (numScore >= 67 && numScore <= 100) {
      return t("blood_pressure_monitoring_good");
    }
    return null;
  };

  const getTherapyAdherenceCategoryText = (score) => {
    if (score === 'N/A' || score === null || score === undefined || score === -1) {
      return null;
    }
    
    const numScore = parseInt(score);
    if (isNaN(numScore)) return null;
    
    // Adjust these ranges based on your scoring system
    if (numScore >= 0 && numScore <= 33) {
      return t("therapy_adherence_poor");
    } else if (numScore >= 34 && numScore <= 66) {
      return t("therapy_adherence_fair");
    } else if (numScore >= 67 && numScore <= 100) {
      return t("therapy_adherence_good");
    }
    return null;
  };

  const getDietCategoryText = (score) => {
    if (score === 'N/A' || score === null || score === undefined || score === -1) {
      return null;
    }
    
    const numScore = parseInt(score);
    if (isNaN(numScore)) return null;
    
    // Adjust these ranges based on your scoring system
    if (numScore >= 0 && numScore <= 33) {
      return t("diet_poor");
    } else if (numScore >= 34 && numScore <= 66) {
      return t("diet_fair");
    } else if (numScore >= 67 && numScore <= 100) {
      return t("diet_good");
    }
    return null;
  };

  const getPhysicalActivityCategoryText = (score) => {
    if (score === 'N/A' || score === null || score === undefined || score === -1) {
      return null;
    }
    
    const numScore = parseInt(score);
    if (isNaN(numScore)) return null;
    
    // Adjust these ranges based on your scoring system
    if (numScore >= 0 && numScore <= 33) {
      return t("physical_activity_low");
    } else if (numScore >= 34 && numScore <= 66) {
      return t("physical_activity_moderate");
    } else if (numScore >= 67 && numScore <= 100) {
      return t("physical_activity_high");
    }
    return null;
  };

  const getSleepCategoryText = (score) => {
    if (score === 'N/A' || score === null || score === undefined || score === -1) {
      return null;
    }
    
    const numScore = parseInt(score);
    if (isNaN(numScore)) return null;
    
    // Adjust these ranges based on your scoring system
    if (numScore >= 0 && numScore <= 33) {
      return t("sleep_poor");
    } else if (numScore >= 34 && numScore <= 66) {
      return t("sleep_fair");
    } else if (numScore >= 67 && numScore <= 100) {
      return t("sleep_good");
    }
    return null;
  };

  // Update the existing getQuestionnaireCategoryText function:
  const getQuestionnaireCategoryText = (questionnaireName, score) => {
    switch(questionnaireName) {
      case 'fagerstrom_test_score':
        return getFagerstromCategoryText(score);
      case 'stress_test_score':
        return getStressCategoryText(score);
      case 'hypertension_awareness_score':
        return getHypertensionAwarenessCategoryText(score);
      case 'blood_pressure_monitoring_score':
        return getBloodPressureMonitoringCategoryText(score);
      case 'therapy_adherence_score':
        return getTherapyAdherenceCategoryText(score);
      case 'diet_score':
        return getDietCategoryText(score);
      case 'physical_activity_score':
        return getPhysicalActivityCategoryText(score);
      case 'sleep_score':
        return getSleepCategoryText(score);
      default:
        return null;
    }
  };

  // const getCardHealthStatusSummary = () => {
  //   if (!patientDetails || patientDetails.length === 0) return { normal: 0, warning: 0, dangerous: 0 };
    
  //   const patient = patientDetails[0];
  //   let normal = 0, warning = 0, dangerous = 0;
    
  //   // Check BMI
  //   if (bmiValue !== 'N/A') {
  //     const bmiStatus = getHealthStatus(parseFloat(bmiValue), HEALTH_THRESHOLDS.bmi);
  //     if (bmiStatus === 'normal') normal++;
  //     else if (bmiStatus === 'warning') warning++;
  //     else if (bmiStatus === 'dangerous') dangerous++;
  //   }
    
  //   // Check cardiovascular risk
  //   if (riskFactor !== -1) {
  //     const riskStatus = getHealthStatus(riskFactor, HEALTH_THRESHOLDS.cardiovascularRisk);
  //     if (riskStatus === 'normal') normal++;
  //     else if (riskStatus === 'warning') warning++;
  //     else if (riskStatus === 'dangerous') dangerous++;
  //   }
    
  //   // Check therapy adherence
  //   if (totalNotifications > 0) {
  //     const adherenceStatus = getHealthStatus(therapyAdherence, HEALTH_THRESHOLDS.therapyAdherence);
  //     if (adherenceStatus === 'normal') normal++;
  //     else if (adherenceStatus === 'warning') warning++;
  //     else if (adherenceStatus === 'dangerous') dangerous++;
  //   }
    
  //   return { normal, warning, dangerous };
  // };

  // // You can use this summary to display an overall health status if needed
  // const healthSummary = getCardHealthStatusSummary();

  return (
    <>
      {token && (
        <div
          className="dashboard d-flex grid-container"
          style={{
            flex: "1 1 auto",
            display: "flex",
            flexFlow: "column",
            height: "100vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              flexFlow: "column",
              height: "100vh",
              overflowY: "auto",
            }}
          >
            <CRow xs={{ gutter: 3 }}>
              <CCol>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: "10px",
                    marginRight: "25px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      marginLeft: "25px",
                    }}
                  >
                    <div className="centered-div">{t("from")}</div>
                    <CFormInput
                      type="date"
                      id="startDate"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      style={{
                        marginRight: "10px",
                        width: "150px",
                        height: "30px",
                        fontSize: "14px",
                      }}
                    />

                    <div className="centered-div">{t("to")}</div>

                    <CFormInput
                      type="date"
                      id="endDate"
                      placeholder="End Date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      style={{
                        marginRight: "10px",
                        width: "150px",
                        height: "30px",
                        fontSize: "14px",
                      }}
                    />

                    <CButton
                      className={`download-button ${loadingByDate ? "outline-button" : ""}`}
                      onClick={handleDateRangeSearch}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                        height: "30px",
                        padding: "0 15px",
                        fontSize: "14px",
                        width: "80px",
                      }}
                      disabled={hasErrorDate || loadingByDate}
                    >
                      {loadingByDate ? (
                        <ClipLoader color="#204770" size={20} />
                      ) : (
                        t("search")
                      )}
                    </CButton>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                      marginLeft: "25px",
                    }}
                  >
                    <CFormInput
                      type="text"
                      id="maxPressure"
                      value={maxPressure}
                      placeholder={t("maxPressure")}
                      onChange={handleMaxPressureChange}
                      style={{
                        marginRight: "10px",
                        width: "100px",
                        height: "30px",
                        fontSize: "14px",
                        borderColor: hasErrorThresholdValidation ? "#dc3545" : undefined,
                      }}
                    />

                    <CFormInput
                      type="text"
                      id="minPressure"
                      value={minPressure}
                      placeholder={t("minPressure")}
                      onChange={handleMinPressureChange}
                      style={{
                        marginRight: "10px",
                        width: "100px",
                        height: "30px",
                        fontSize: "14px",
                        borderColor: hasErrorThresholdValidation ? "#dc3545" : undefined,
                      }}
                    />

                    <CButton
                      className={`download-button ${loadingByPressure ? "outline-button" : ""}`}
                      onClick={handleConfirmPressure}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                        height: "30px",
                        padding: "0 5px",
                        fontSize: "14px",
                        width: "230px",
                      }}
                          disabled={hasErrorDate || hasErrorPressure || hasErrorThresholdValidation || loadingByPressure}
                    >
                      {loadingByPressure ? (
                        <ClipLoader color="#204770" size={20} />
                      ) : (
                        t("confirm_pressure_threshold")
                      )}
                    </CButton>
                  </div>
                  
                  <CDropdown variant="btn-group">
                    <CDropdownToggle className="download-button" style={{
                      height: "30px",
                      width: "150px",
                      fontSize: "14px",
                    }}>{ t("downloadFiles") }</CDropdownToggle>
                    <CDropdownMenu> 
                      <CDropdownItem onClick={downloadExcel}>XLSX</CDropdownItem>
                      {/* <CDropdownItem onClick={downloadPDF}>PDF</CDropdownItem> */}
                    </CDropdownMenu>
                  </CDropdown>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <div className="divider-page"></div>
            </CRow>

            {(hasErrorDate || hasErrorPressure || hasErrorThresholdValidation) && (
            <CRow>
              <CCol>
                <div style={{ color: "red", marginLeft: "25px" }}>
                  {/* Show individual errors when only one type exists */}
                  {hasErrorDate && !hasErrorPressure && !hasErrorThresholdValidation && 
                    t("start_date_cannot_be_after_end_date")
                  }
                  
                  {hasErrorPressure && !hasErrorDate && !hasErrorThresholdValidation && 
                    t("the_max_pressure_should_be_greater_than_the_min_pressure")
                  }

                  {hasErrorThresholdValidation && !hasErrorDate && !hasErrorPressure && 
                    thresholdValidationError
                  }

                  {/* Show combined errors when multiple types exist */}
                  {((hasErrorDate && hasErrorPressure) || 
                    (hasErrorDate && hasErrorThresholdValidation) || 
                    (hasErrorPressure && hasErrorThresholdValidation) || 
                    (hasErrorDate && hasErrorPressure && hasErrorThresholdValidation)) && (
                    <>
                      {hasErrorDate && (
                        <>
                          {t("start_date_cannot_be_after_end_date")}
                          {(hasErrorPressure || hasErrorThresholdValidation) && <br />}
                        </>
                      )}
                      {hasErrorPressure && (
                        <>
                          {t("the_max_pressure_should_be_greater_than_the_min_pressure")}
                          {hasErrorThresholdValidation && <br />}
                        </>
                      )}
                      {hasErrorThresholdValidation && thresholdValidationError}
                    </>
                  )}
                </div>
              </CCol>
            </CRow>
          )}

            <CRow xs={{ gutter: 3 }}>
              <CCol xs={4}>
                <CRow>
                  <div>
                    <PatientDetailsCard
                      details={patientDetails[0]}
                      loading={loadingPatientInfo}
                      title={t("patientInformation")}
                      tooltipInfo={t("patient_info_tooltip")}
                    />
                  </div>
                </CRow>
                <CRow>
                  <div className="divider-scatter"></div>
                </CRow>

                <CRow>
                  <div>
                    <CCardDashboard
                      loading={loadingCardioRisk}
                      title={t("cardiovascularRiskFactor")}
                      number={riskFactor !== -1 ? getCardiovascularRiskText(riskFactor) : "N/A"}
                      tooltipInfo={t("cardio_vascular_risk_tooltip_info")}
                      patientData={patientDetails[0]} // Add this line
                      healthMetricTag={HEALTH_METRIC_TAGS.CARDIOVASCULAR_RISK}
                    />
                  </div>
                </CRow>
                <CRow>
                  <div className="divider-scatter"></div>
                </CRow>
                {/* <CRow>
                  <div>
                    <CCardDashboard
                      title={t("bmiValue")}
                      number={bmiValue}
                      secondaryTitle={getBMICategoryText(bmiValue)}
                      loading={loadingBMI}
                      tooltipInfo={t("bmi_tooltip_info")}
                      patientData={patientDetails[0]}
                      healthMetricTag={HEALTH_METRIC_TAGS.BMI_VALUE}
                    />
                  </div>
                </CRow> */}
              </CCol>
              <CCol xs={8}>
                {!loadingPressureScatter &&
                  minBloodPressureData.length === 0 &&
                  maxBloodPressureData.length === 0 && (
                    <div className="scatter-div">
                      <p>{t("no_data_found_in_the_selected_date_range")}</p>
                    </div>
                  )}

                {loadingPressureScatter && (
                  <div className="scatter-div">
                    <ClipLoader
                      color="#204770"
                      loading={loadingTherapies}
                      // cssOverride={override}
                      size={80}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div>
                )}

                {!loadingPressureScatter &&
                  minBloodPressureData.length > 0 &&
                  maxBloodPressureData.length > 0 &&
                  thresholdData && (
                    <ScatterPlotContainer>
                      <ScatterPlot data={scatterPlotData} thresholdData={thresholdData}/>
                    </ScatterPlotContainer>
                  )}
              </CCol>
            </CRow>

            <CRow>
              <div className="divider-page"></div>
            </CRow>

            <CRow xs={{ gutter: 3 }}>
              <CCol xs={4}>
                <Swiper
                  // modules={[Navigation, Pagination]}
                  spaceBetween={0}
                  navigation={true}
                  slidesPerView={1}
                  // pagination={{clickable: true}}
                  scrollbar={{ draggable: true }}
                  className="swiper-slide"
                >
                  <SwiperSlide key={0}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("maxBloodPressure")}
                      secondaryTitle={t("average")}
                      number={avgMaxPressure}
                      tooltipInfo={t("maxPressure_info")}
                      patientData={patientDetails[0]}
                      healthMetricTag={HEALTH_METRIC_TAGS.AVERAGE_SYSTOLIC_PRESSURE}
                    />
                  </SwiperSlide>
                  <SwiperSlide key={1}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("maxBloodPressure")}
                      secondaryTitle={t("maximum")}
                      number={maxMaxPressure}
                      tooltipInfo={t("maxPressure_info")}
                      healthMetricTag={HEALTH_METRIC_TAGS.MAX_SYSTOLIC_PRESSURE}
                    />
                  </SwiperSlide>

                  <SwiperSlide key={2}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("maxBloodPressure")}
                      secondaryTitle={t("minimum")}
                      number={minMaxPressure}
                      tooltipInfo={t("maxPressure_info")}
                      healthMetricTag={HEALTH_METRIC_TAGS.MIN_SYSTOLIC_PRESSURE}
                    />
                  </SwiperSlide>
                  <SwiperSlide key={3}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("maxBloodPressure")}
                      secondaryTitle={t("number_of_measurements")}
                      number={numMeasurementMaxPressure}
                      tooltipInfo={t("maxPressure_info")}
                      healthMetricTag={HEALTH_METRIC_TAGS.NUMBER_SYSTOLIC_MEASUREMENTS}
                    />
                  </SwiperSlide>
                </Swiper>
              </CCol>
              <CCol xs={4}>
                <Swiper
                  // modules={[Navigation, Pagination]}
                  spaceBetween={0}
                  navigation={true}
                  slidesPerView={1}
                  // pagination={{clickable: true}}
                  scrollbar={{ draggable: true }}
                  className="swiper-slide"
                >
                  <SwiperSlide>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("minBloodPressure")}
                      secondaryTitle={t("average")}
                      number={avgMinPressure}
                      tooltipInfo={t(
                        "minPressure_info",
                        "minimum_pressure_summary",
                      )}
                      patientData={patientDetails[0]}
                      healthMetricTag={HEALTH_METRIC_TAGS.AVERAGE_DIASTOLIC_PRESSURE}
                    />
                  </SwiperSlide>
                  <SwiperSlide key={1}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("minBloodPressure")}
                      secondaryTitle={t("maximum")}
                      number={maxMinPressure}
                      tooltipInfo={t(
                        "minPressure_info",
                        "minimum_pressure_summary",
                      )}
                      healthMetricTag={HEALTH_METRIC_TAGS.MAX_DIASTOLIC_PRESSURE}
                    />
                  </SwiperSlide>

                  <SwiperSlide key={2}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("minBloodPressure")}
                      secondaryTitle={t("minimum")}
                      number={minMinPressure}
                      tooltipInfo={t(
                        "minimum_pressure_summary",
                        "minPressure_info",
                      )}
                      healthMetricTag={HEALTH_METRIC_TAGS.MIN_DIASTOLIC_PRESSURE}
                    />
                  </SwiperSlide>

                  <SwiperSlide key={3}>
                    <CCardDashboard
                      loading={loadingPressureScatter}
                      title={t("minBloodPressure")}
                      secondaryTitle={t("number_of_measurements")}
                      number={numMeasurementMinPressure}
                      tooltipInfo={t("minPressure_info")}
                      healthMetricTag={HEALTH_METRIC_TAGS.NUMBER_DIASTOLIC_MEASUREMENTS}
                    />
                  </SwiperSlide>
                </Swiper>
              </CCol>

              <CCol xs={4}>
                <div>
                  <Swiper
                    spaceBetween={0}
                    navigation={true}
                    slidesPerView={1}
                    scrollbar={{ draggable: true }}
                    className="swiper-slide"
                  >
                    <SwiperSlide key={0}>
                      <CCardDashboard
                        loading={loadingHeartRate}
                        title={t("heart_rate")}
                        secondaryTitle={t("average")}
                        number={avgHeartRate}
                        tooltipInfo={t("heart_rate_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.AVERAGE_HEART_RATE}
                      />
                    </SwiperSlide>
                    <SwiperSlide key={1}>
                      <CCardDashboard
                        loading={loadingHeartRate}
                        title={t("heart_rate")}
                        secondaryTitle={t("maximum")}
                        number={maxHeartRate}
                        tooltipInfo={t("heart_rate_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.MAX_HEART_RATE}
                      />
                    </SwiperSlide>
                    <SwiperSlide key={2}>
                      <CCardDashboard
                        loading={loadingHeartRate}
                        title={t("heart_rate")}
                        secondaryTitle={t("minimum")}
                        number={minHeartRate}
                        tooltipInfo={t("heart_rate_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.MIN_HEART_RATE}
                      />
                    </SwiperSlide>
                    <SwiperSlide key={3}>
                      <CCardDashboard
                        loading={loadingHeartRate}
                        title={t("heart_rate")}
                        secondaryTitle={t("number_of_measurements")}
                        number={numMeasurementHeartRate}
                        tooltipInfo={t("heart_rate_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.NUMBER_HEART_RATE_MEASUREMENTS}
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </CCol>
              
            </CRow>

            <CRow>
              <div className="divider-page"></div>
            </CRow>


            <CRow xs={{ gutter: 3 }}>
              <CCol xs={4}>
                  <div style={{}}>
                    <CCardDashboard
                      title={t("bmiValue")}
                      number={bmiValue}
                      secondaryTitle={getBMICategoryText(bmiValue)}
                      loading={loadingBMI}
                      tooltipInfo={t("bmi_tooltip_info")}
                      patientData={patientDetails[0]}
                      healthMetricTag={HEALTH_METRIC_TAGS.BMI_VALUE}
                    />
                  </div>
              </CCol>

              <CCol xs={4}>
                <div style={{}}>
                  <Swiper
                    // modules={[Navigation, Pagination]}
                    spaceBetween={0}
                    navigation={true}
                    slidesPerView={1}
                    // pagination={{clickable: true}}
                    scrollbar={{ draggable: true }}
                    className="swiper-slide"
                  >
                    <SwiperSlide key={0}>
                      <CCardDashboard
                        loading={loadingBenedict}
                        title={t("benedictValue")}
                        number={benedictValue}
                        tooltipInfo={t("benedict_value_tooltip_info")}
                        patientData={patientDetails[0]} 
                        healthMetricTag={HEALTH_METRIC_TAGS.BENEDICT_VALUE}
                      />
                    </SwiperSlide>
                    <SwiperSlide key={1}>
                      <CCardDashboard
                        loading={loadingPalValue}
                        title={t("palValue")}
                        number={palValue !== -1.0 ? palValue : "N/A"}
                        secondaryTitle={palValue !== -1.0 ? getPALCategoryText(palValue) : null}
                        tooltipInfo={t("palValue_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.PAL_VALUE}
                      />
                    </SwiperSlide>
                    <SwiperSlide key={2}>
                      <CCardDashboard
                        loading={loadingTeeValue}
                        title={t("teeValue")}
                        number={teeValue}
                        tooltipInfo={t("teeValue_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.TEE_VALUE}
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </CCol>

              <CCol xs={4}>
                <Swiper
                  // modules={[Navigation, Pagination]}
                  spaceBetween={0}
                  navigation={true}
                  slidesPerView={1}
                  // pagination={{clickable: true}}
                  scrollbar={{ draggable: true }}
                  className="swiper-slide"
                >
                  {
                    questionnaireData.map((quest, ind) => 
                      <SwiperSlide key={ind}>
                        <CCardDashboard
                          loading={loadingQuestionnaire}
                          title={t(quest.name)}
                          number={quest.score}
                          secondaryTitle={getQuestionnaireCategoryText(quest.name, quest.score)}
                          tooltipInfo={t(`${quest.name}_info`)}
                          patientData={patientDetails[0]}
                          healthMetricTag={quest.healthMetricTag}
                        />
                      </SwiperSlide>
                    )
                  }
                </Swiper>
              </CCol>
              {/* <CCol xs={4}>
                <CCardDashboard
                      loading={loadingEducationalNotifications}
                      title={t('userEducationalNotifications')}
                      number={educationalNotifications ? educationalNotifications.length: ''}
                      tooltipInfo={t('userEducationalNotifications_info')}
                      healthMetricTag={HEALTH_METRIC_TAGS.EDUCATIONAL_NOTIFICATIONS}
                />
              </CCol> */}
              {/* <CCol xs={4}>
                <CCardDashboard
                      loading={loadingEducationalNotifications}
                      title={t('userEducationalNotifications')}
                      number={educationalNotifications ? educationalNotifications.length: ''}
                      tooltipInfo={t('userEducationalNotifications_info')}
                      healthMetricTag={HEALTH_METRIC_TAGS.EDUCATIONAL_NOTIFICATIONS}
                />
              </CCol> */}
              
              {/* <CCol xs={4}>
                <div>
                  <Swiper
                    // modules={[Navigation, Pagination]}
                    spaceBetween={0}
                    navigation={true}
                    slidesPerView={1}
                    // pagination={{clickable: true}}
                    scrollbar={{ draggable: true }}
                    className="swiper-slide"
                  >
                    <SwiperSlide key={0}>
                      <CCardDashboard
                        loading={loadingAdherence}
                        title={t("therapyAdherence")}
                        number={
                          totalNotifications > 0
                            ? therapyAdherence.toFixed(2) + "%"
                            : "N/A"
                        }
                        tooltipInfo={t("therapy_adherence_tooltip_info")}
                        patientData={patientDetails[0]}
                        healthMetricTag={HEALTH_METRIC_TAGS.THERAPY_ADHERENCE}
                      />
                    </SwiperSlide>
                    <SwiperSlide key={1}>
                      <CCardDashboard
                        loading={loadingAdherence}
                        title={t("respectedAssumptions")}
                        number={`${correctAssumptions}/${totalNotifications}`}
                        tooltipInfo={t("respectedAssumptions_info")}
                        healthMetricTag={HEALTH_METRIC_TAGS.RESPECTED_ASSUMPTIONS}
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </CCol> */}
            </CRow>

            <CRow>
              <div className="divider-page"></div>
            </CRow>

            <CRow xs={{ gutter: 3 }}>
              <CCol xs={4}>
                {!loadingTherapies && (
                  <Swiper
                    // modules={[Navigation, Pagination]}
                    slidesPerView={1}
                    spaceBetween={0}
                    navigation={true}
                    pagination={{ clickable: true }}
                    className="swiper-slide"
                  >
                    {therapies.length > 0 &&
                      therapies.map((therapy, index) => (
                        <SwiperSlide key={index}>
                          <MedicineCard
                            medicineUnit={therapy.drugUnit}
                            medicineName={therapy.drugName}
                            frequency={therapy.daysOfTheWeek}
                            intake={therapy.intake}
                            loading={loadingTherapies}
                            tooltipInfo={t("therapy_info_tooltip")}
                            intervalUnit={therapy.intervalUnit}
                            drugRegularityId={therapy.drugRegularityId}
                            intervalNumber={therapy.intervalNumber}
                            startDate={therapy.startDate}
                            endDate={therapy.endDate}
                            adherencePercentage={therapy.adherencePercentage}
                            patientData={patientDetails[0]}
                          />
                        </SwiperSlide>
                      ))}
                    {therapies.length === 0 && (
                      <SwiperSlide>
                        <MedicineCard
                          medicineUnit={""}
                          medicineName={""}
                          frequency={""}
                          intake={""}
                          loading={false}
                          tooltipInfo={t("therapy_info_tooltip")}
                          adherencePercentage={null} // No adherence for empty card
                          patientData={patientDetails[0]}
                        />
                      </SwiperSlide>
                    )}
                  </Swiper>
                )}
                {loadingTherapies && (
                  <div className="loading-div">
                    <ClipLoader
                      color="white"
                      loading={loadingTherapies}
                      // cssOverride={override}
                      size={80}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div>
                )}
              </CCol>
              <CCol xs={4}>
                <Swiper
                      // modules={[Navigation, Pagination]}
                      spaceBetween={0}
                      navigation={true}
                      slidesPerView={1}
                      // pagination={{clickable: true}}
                      scrollbar={{ draggable: true }}
                      className="swiper-slide"
                    >
                      <SwiperSlide key={0}>
                        <ListCard
                          lifestyle={initialAnamnesis}
                          title={t("lifestyleInformation")}
                          loading={loadingLifestyle}
                          tooltipInfo={t("life_style_info_tooltip")}
                        />
                      </SwiperSlide>
                      <SwiperSlide key={1}>
                        <ListCard
                          lifestyle={pathologies}
                          title={t("pathologies")}
                          loading={loadingTherapies}
                          tooltipInfo={t("comorbidities_info_tooltip")}
                        />
                      </SwiperSlide>
                </Swiper>
              </CCol>
              <CCol xs={4}>
                <Swiper
                      // modules={[Navigation, Pagination]}
                      spaceBetween={0}
                      navigation={true}
                      slidesPerView={1}
                      // pagination={{clickable: true}}
                      scrollbar={{ draggable: true }}
                      className="swiper-slide"
                    >
                      {
                        educationalNotifications && 
                        educationalNotifications.length > 0 &&
                        educationalNotifications.slice(0,50).map((notification, ind) => <SwiperSlide key={ind}>
                          <NotificationCard
                            title={notification.title}
                            body={notification.body}
                            timestamp={notification.timestamp}
                            loading={loadingEducationalNotifications}
                            tooltipInfo={t("educationalNotificationCardTitle_info")}
                          />
                        </SwiperSlide>)
                      }
                      {
                        educationalNotifications && 
                        educationalNotifications.length === 0 &&
                        <SwiperSlide key={0}>
                          <NotificationCard
                            title={""}
                            body={""}
                            timestamp={""}
                            loading={loadingEducationalNotifications}
                            tooltipInfo={t("educationalNotificationCardTitle_info")}
                          />
                        </SwiperSlide>
                      }
                </Swiper>
              </CCol>
            </CRow>

            <CRow>
              <div className="divider-page"></div>
            </CRow>
          </div>
        </div>
      )}
      {!token && <div className="login-container"></div>}
      <LogoutModal
        show={showLogoutModal}
        handleConfirm={handleConfirm}
        handleClose={handleConfirm}
        title={t("login")}
        message={t("session_expired_please_login_again")}
        tag={"Login"}
      />
    </>
  );
};

UserDetailsPage.UserDetailsPage = {};
export default UserDetailsPage;
